import classNames from "classnames";
import * as checkMobile from "is-mobile";
import { isEmpty, sortBy } from "lodash";
import moment from "moment";
import { withSnackbar } from "notistack";
import propTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import { compose } from "recompose";
import * as yup from "yup";

import {
  Button,
  Checkbox,
  Drawer,
  Grid,
  IconButton,
  MuiThemeProvider,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";

import * as L from "leaflet";
import { AttributionControl, Map, ScaleControl, TileLayer } from "react-leaflet";

import { Field, Form, Formik } from "formik";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete } from "@material-ui/lab";
import FormikTextField from "formik-material-fields/lib/FormikTextField";

import {
  AddLocationTwoTone,
  BuildTwoTone,
  Check,
  Clear,
  DoubleArrow,
  HelpOutlineTwoTone,
  HomeTwoTone,
  LabelOffTwoTone,
  MapTwoTone,
  MouseTwoTone,
  MyLocationTwoTone,
  RedoTwoTone,
  SatelliteTwoTone,
  SearchTwoTone,
  SettingsBackupRestore,
  TouchAppTwoTone,
  ZoomInTwoTone,
  ZoomOutMapTwoTone,
  ZoomOutTwoTone,
} from "@material-ui/icons";

import {
  faAt,
  faBuilding,
  faCity,
  faHouseChimney,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

import {
  Commune,
  EligibilitePro,
  GeoCodage,
  Immeuble,
  Marche,
  Prospect,
  Version,
} from "../../services";

import { setLogoFromDsp } from "../../utils";

import Legende from "./Legende";
import MarkersImb from "./MarkersImb";
import ZaAmiiVN from "./ZaAmiiVN";
import ZaCommune from "./ZaCommune";
import ZaMarche from "./ZaMarche";
import ZaRadioVN from "./ZaRadioVN";
import ZaSro from "./ZaSro";

import { Input, CheckBox as IrrisCheckBox, RadioGroup, Spinner } from "../../components";
import { yupHexacle, yupLatLong } from "../../plugins/yup";

import {
  ButtonClose,
  ButtonTheme,
  CheckboxTheme,
  DrawerEligibiliteSearchTheme,
  DrawerEligibiliteSearchThemeClosed,
  MenuIconsTheme,
} from "../../assets/css/App";
import "../../assets/css/Forms.scss";
import "./Eligibilite.scss";

import { colorIcons, couleurZaDeploiement } from "../../enums";

const LAYER_GOOGLE = "https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}";
const LAYER_OSM = "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
const isMobile = checkMobile({ tablet: true });

/* Constantes carto
  MAX_BOUNDS : Limite cartographique de la france cf https://epsg.io/27572-8094
  POSITION_CENTER : Centre de la France
*/
const MAX_BOUNDS = L.latLngBounds(L.latLng(40.31, -5.87), L.latLng(52.14, 10.63));
const POSITION_CENTER = [46.599010068591, 2.712213037499982];
const ZOOM_LEVEL_IMB = 16;
const ZOOM_LEVEL_FTTE = 16;
const MAX_ZOOM_DISPLAY_MARCHE = 15;
const MAX_ZOOM_DISPLAY_SRO = 9;
const MAX_ZOOM_DISPLAY_AMII = 9;
const MIN_ZOOM_DISPLAY_SRO = 15;
const MIN_ZOOM_DISPLAY_AMII = 15;
const MAX_ZOOM_DISPLAY_LEGENDE = 6;
const MAX_ZOOM_MAP = 19;
const MIN_ZOOM_MAP = 6;

// Constantes des tooltips
const tooltipImb = isVisible => `${isVisible ? "Cacher" : "Afficher"} les immeubles`;
const tooltipHelp = isVisible => `${isVisible ? "Cacher" : "Afficher"} l'aide`;
const tooltipZoomOut = "Zoom arrière";
const tooltipZoomIn = "Zoom avant";
const tooltipSearch = "Rechercher par adresse";
const tooltipAddAdress = "Ajouter une adresse";
const tooltipSetting = "Options de la carte";
const tooltipGeoloc = "Me géolocaliser";
const tooltipResetMapZoom = "Recentrer la carte";
const tooltipHideLegende = isVisible => `${isVisible ? "Cacher" : "Afficher"} la légende`;
const tooltipInfoRadio =
  "Solution fiable et performante d'accès à internet pour tous les habitants ne disposant pas d'une liaison ADSL haut débit : le TD-LTE, dénommé Très Haut Débit Radio...";
const tooltipInfoAMII =
  "En Vendée, plusieurs secteurs, font actuellement l'objet d'un déploiement de la fibre optique par un opérateur commercial privé (Orange)";
const tooltipInfoFTTE =
  "La fibre FttE (Fiber to the Enterprise ) constitue une offre uniquement accessible pour les professionnels";

const mapContainerRef = React.createRef();
const mapRef = React.createRef();

const Eligibilite = ({ dsp, enqueueSnackbar }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // States de cancel des requête axios et fetch
  const abortInit = new AbortController();
  const [abortInfosImb, setAbortInfosImb] = useState(new AbortController());
  const [abortEligPro, setAbortEligPro] = useState(new AbortController());
  const [abortVoies, setAbortVoies] = useState(new AbortController());
  const [abortNumeros, setAbortNumeros] = useState(new AbortController());

  // States d'initialisation
  const [isInit, setIsInit] = useState(true);
  const [isLoadingZaMarche, setIsLoadingZaMarche] = useState(true);
  const [isLoadingZaSro, setIsLoadingZaSro] = useState(true);
  const [isLoadingZaAmiiVN, setIsLoadingZaAmiiVN] = useState(dsp.codeReseau === "AI-VENU");
  const [isLoadingZaRadioVN, setIsLoadingZaRadioVN] = useState(dsp.codeReseau === "AI-VENU");
  const [isOpenTooltipHelper, setIsOpenTooltipHelper] = useState(true);

  // States de chargement
  const [isLoading, setIsLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(true);

  /*
   ** States du Drawer.
   ** openSetting est ouvert par défaut, si aucune referenceImb n'est présente en urlParam (sur grand écran)
   ** openSearch est ouvert par défaut si une referenceImb est présente en urlParams
   ** openElig est toujours à false par défaut
   */
  const [openSetting, setOpenSetting] = useState(
    !params.get("referenceImb") && window.innerWidth >= 992,
  );
  const [openSearch, setOpenSearch] = useState(params.get("referenceImb"));
  const [openElig, setOpenElig] = useState(false);

  /* States de la carto
    urlLayer : Change le fond de carte
    visibleHeight : Réduit la hauteur de la carte
    isMobileLandscape : Flag pour set la taille max des popups
    imbWkt : Récupére la zone visible de la carte
    resetCoordonnees : Flag réinitialisant la carte
    isAutoPanning : Flag empêchant un double refresh pendant l'autopanning
  */
  const [urlLayer, setUrlLayer] = useState(LAYER_OSM);
  const [zoom, setZoom] = useState(4.5);
  const [visibleHeight, setVisibleHeight] = useState(window.innerHeight);
  const [currentWidth, setCurrentWidth] = useState(window.innerWidth);
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);
  const [imbWkt, setImbWkt] = useState({});
  const [resetCoordonnees, setResetCoordonees] = useState(false);
  const [isAutoPanning, setIsAutoPanning] = useState(false);
  const [positionMarkerTarget, setPositionMarkerTarget] = useState(null);

  // States liés à la carto
  const [openMenu, setOpenMenu] = useState(true);
  const [displayLegende, setDisplayLegende] = useState(window.innerWidth >= 992);
  const [displayMarkerImb, setDisplayMarkerImb] = useState(true);
  const [tooltipImbDisplay, setTooltipImbDisplay] = useState(false);
  const [chargementIMBWtk, setChargementIMBWtk] = useState(false);
  const [dateVersion, setDateVersion] = useState("");
  const [tooltip, setTooltip] = useState("Passer en vue satellite");
  const [imageButton, setImageButton] = useState(
    <SatelliteTwoTone className="IconSatellite" fontSize="large" />,
  );

  // State de configuration de la carte
  const [optionSelectedConfigCarte, setOptionSelectedConfigCarte] = useState({
    LAYER_PLAN: true,
    LAYER_SAT: false,
    ALL_ZONES: true,
    SRO_DEP_201820: true,
    SRO_DEP_2021: true,
    SRO_DEP_2022: true,
    SRO_DEP_2023: true,
    SRO_OPEN: true,
    SRO_SOON: true,
    SRO_YEAR_NX: dsp.codeReseau === "AI-MNUM",
    SRO_YEAR_N0: !(dsp.maxYear && dsp.maxYear < moment().year() + 0),
    SRO_YEAR_N1: !(dsp.maxYear && dsp.maxYear < moment().year() + 1),
    SRO_YEAR_N2: !(dsp.maxYear && dsp.maxYear < moment().year() + 2),
    ZONE_RADIO: false,
    ZONE_AMII: true,
    ALL_STATUSES: true,
    IMB_RAC: true,
    IMB_ELIG: true,
    IMB_PROELIG: true,
    IMB_ETUDE: true,
    IMB_BLOC_COLLECTIF_TIERS: true,
    IMB_DEMANDE: dsp.codeReseau !== "AI-JURA",
    IMB_GELCOM: dsp.codeReseau !== "AI-VENU",
    IMB_TRAVAUX_SECTEUR: dsp.codeReseau === "AI-VENU",
    IMB_TRAVAUX_RUE: dsp.codeReseau === "AI-VENU",
    FTTE: false,
  });

  // Paramètres formulaire prospect, affichage conditionnel des champs et gestion des valeurs des champs
  const [prospectInitialValues, setProspectInitialValues] = useState(null);
  const [displayProspect, setDisplayProspect] = useState(false);
  const [prospectSent, setProspectSent] = useState(false);

  // Paramètres formulaire recherche, affichage conditionnel des champs et gestion des valeurs des champs
  const [disableIMBField, setDisableIMBField] = useState(false);
  const [disableHexacleField, setDisableHexacleField] = useState(false);
  const [disableLatLongField, setDisableLatLongField] = useState(false);
  const [disableSIRETField, setDisableSIRETField] = useState(false);
  const [displayRecherche, setDisplayRecherche] = useState(true);
  const [displaySpecific, setDisplaySpecific] = useState(true);
  const [displayAdresse, setDisplayAdresse] = useState(true);
  const [disableVoie, setDisableVoie] = useState(true);
  const [disableNumero, setDisableNumero] = useState(true);
  const [valueMarche, setValueMarche] = useState(null);
  const [valueCommune, setValueCommune] = useState(null);
  const [valueVoie, setValueVoie] = useState(null);
  const [valueNumero, setValueNumero] = useState(null);
  const [valueLAT, setValueLAT] = useState(null);
  const [valueLONG, setValueLONG] = useState(null);
  const [codeInsee, setCodeInsee] = useState(null);
  const [disableSearchButton, setDisableSearchButton] = useState(true);
  const [displayNoResultat, setDisplayNoResultat] = useState(false);
  const [selectedRow, setSelectedRow] = useState(-1);

  // Liste marche / Commune / voie / Numéro
  const [marcheList, setMarcheList] = useState([]);
  const [communeList, setCommuneList] = useState([]);
  const [voiesList, setVoiesList] = useState([]);
  const [numerosList, setNumerosList] = useState([]);

  // Informations des immeubles FTTH / FTTE
  const [infoImmeuble, setInfoImmeuble] = useState();
  const [listeImmeublesParAdresse, setListeImmeublesParAdresse] = useState([]);
  const [infoEligPro, setInfoEligPro] = useState(null);

  // Constante d'ouverture et de fermeture du menu latéral
  const swipeHandler = useSwipeable({
    onSwipedLeft: () => setOpenMenu(true),
    onSwipedRight: () => setOpenMenu(false),
  });

  /**
   * Gère l'ouverture des différents drawer
   * @param {string} drawer Le drawer à ouvrir. Si "", ferme tous les drawers
   */
  const handleDrawerLeftOpen = async (drawer = "") => {
    if (drawer === "openElig") {
      if (openElig) {
        setInfoEligPro(null);
        setOpenSearch(false);
        setOpenSetting(false);
        setOpenElig(false);

        setTimeout(() => {
          setOpenSearch(true);
          setDisplayProspect(false);
          setDisplayRecherche(true);
        }, 1000);
      } else {
        setOpenSearch(true);
        setOpenSetting(false);
        setOpenElig(false);

        setDisplayRecherche(true);
      }
    } else if (drawer === "openSearch") {
      setOpenSearch(true);
      setOpenElig(false);
      setOpenSetting(false);
    } else if (drawer === "openSetting") {
      setOpenSearch(false);
      setOpenElig(false);
      setOpenSetting(true);
    } else {
      setOpenSearch(false);
      setOpenElig(false);
      setOpenSetting(false);
    }
  };

  /**
   * Reset la configuration de la carte
   */
  const handleResetConfigMap = () => {
    setOptionSelectedConfigCarte({
      ...optionSelectedConfigCarte,
      LAYER_PLAN: true,
      LAYER_SAT: false,
      ALL_ZONES: true,
      SRO_DEP_201820: true,
      SRO_DEP_2021: true,
      SRO_DEP_2022: true,
      SRO_DEP_2023: true,
      SRO_OPEN: true,
      SRO_SOON: true,
      SRO_YEAR_NX: dsp.codeReseau === "AI-MNUM",
      SRO_YEAR_N0: !(dsp.maxYear && dsp.maxYear < moment().year() + 0),
      SRO_YEAR_N1: !(dsp.maxYear && dsp.maxYear < moment().year() + 1),
      SRO_YEAR_N2: !(dsp.maxYear && dsp.maxYear < moment().year() + 2),
      ZONE_RADIO: false,
      ZONE_AMII: true,
      ALL_STATUSES: true,
      IMB_RAC: true,
      IMB_ELIG: true,
      IMB_PROELIG: true,
      IMB_ETUDE: true,
      IMB_BLOC_COLLECTIF_TIERS: true,
      IMB_DEMANDE: dsp.codeReseau !== "AI-JURA",
      IMB_GELCOM: dsp.codeReseau !== "AI-VENU",
      IMB_TRAVAUX_SECTEUR: dsp.codeReseau === "AI-VENU",
      IMB_TRAVAUX_RUE: dsp.codeReseau === "AI-VENU",
      FTTE: false,
    });

    setUrlLayer(LAYER_OSM);
    setTooltip("Passer en vue satellite");
    setImageButton(<SatelliteTwoTone className="IconSatellite" fontSize="large" />);
  };

  /**
   * Gère la configuration de la carte suivant les checkboxs
   * @param {HTMLElement} e La checkbox modifiée
   */
  const handleChangeCheckBoxConfigCarte = e => {
    switch (e.target.value) {
      case "LAYER_PLAN":
        if (e.target.checked) {
          setOptionSelectedConfigCarte({
            ...optionSelectedConfigCarte,
            LAYER_PLAN: true,
            LAYER_SAT: false,
          });
          setUrlLayer(LAYER_OSM);
          setTooltip("Passer en vue satellite");
          setImageButton(<SatelliteTwoTone className="IconSatellite" fontSize="large" />);
        }
        break;
      case "LAYER_SAT":
        if (e.target.checked) {
          setOptionSelectedConfigCarte({
            ...optionSelectedConfigCarte,
            LAYER_SAT: true,
            LAYER_PLAN: false,
          });
          setUrlLayer(LAYER_GOOGLE);
          setTooltip("Passer en vue plan");
          setImageButton(<MapTwoTone className="IconMap" fontSize="large" />);
        }
        break;
      case "ALL_ZONES":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          ALL_ZONES: e.target.checked,
          SRO_DEP_201820: e.target.checked,
          SRO_DEP_2021: e.target.checked,
          SRO_DEP_2022: e.target.checked,
          SRO_DEP_2023: e.target.checked,
          SRO_OPEN: e.target.checked,
          SRO_SOON: e.target.checked,
          SRO_YEAR_NX: dsp.codeReseau === "AI-MNUM" && e.target.checked,
          SRO_YEAR_N0: !(dsp.maxYear && dsp.maxYear < moment().year() + 0) && e.target.checked,
          SRO_YEAR_N1: !(dsp.maxYear && dsp.maxYear < moment().year() + 1) && e.target.checked,
          SRO_YEAR_N2: !(dsp.maxYear && dsp.maxYear < moment().year() + 2) && e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_DEP_201820":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_DEP_201820: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_DEP_2020":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_DEP_2020: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_DEP_2021":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_DEP_2021: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_DEP_2022":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_DEP_2022: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_DEP_2023":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_DEP_2023: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_OPEN":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_OPEN: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_SOON":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_SOON: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_YEAR_NX":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_YEAR_NX: e.target.checked,
          SRO_YEAR_N0: e.target.checked,
          SRO_YEAR_N1: e.target.checked,
          SRO_YEAR_N2: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_YEAR_N0":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_YEAR_N0: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_YEAR_N1":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_YEAR_N1: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "SRO_YEAR_N2":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          SRO_YEAR_N2: e.target.checked,
          ZONE_RADIO: false,
        });
        break;
      case "ZONE_RADIO":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          ZONE_RADIO: e.target.checked,
          ALL_ZONES: false,
          SRO_DEP_201820: false,
          SRO_DEP_2021: false,
          SRO_DEP_2022: false,
          SRO_DEP_2023: false,
        });
        break;
      case "ZONE_AMII":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          ZONE_AMII: e.target.checked,
        });
        break;
      case "FTTE":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          FTTE: e.target.checked,
          ALL_STATUSES: false,
          IMB_RAC: false,
          IMB_ELIG: false,
          IMB_PROELIG: false,
          IMB_ETUDE: false,
          IMB_DEMANDE: false,
          IMB_GELCOM: false,
          IMB_TRAVAUX_SECTEUR: false,
          IMB_TRAVAUX_RUE: false,
        });
        break;
      case "ALL_STATUSES":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          ALL_STATUSES: e.target.checked,
          IMB_RAC: e.target.checked,
          IMB_ELIG: e.target.checked,
          IMB_PROELIG: e.target.checked,
          IMB_ETUDE: e.target.checked,
          IMB_BLOC_COLLECTIF_TIERS: e.target.checked,
          IMB_DEMANDE: dsp.codeReseau !== "AI-JURA" && e.target.checked,
          IMB_GELCOM: dsp.codeReseau !== "AI-VENU" && e.target.checked,
          IMB_TRAVAUX_SECTEUR: dsp.codeReseau === "AI-VENU" && e.target.checked,
          IMB_TRAVAUX_RUE: dsp.codeReseau === "AI-VENU" && e.target.checked,
          FTTE: false,
        });
        break;
      case "IMB_RAC":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_RAC: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_ELIG":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_ELIG: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_PROELIG":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_PROELIG: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_ETUDE":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_ETUDE: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_DEMANDE":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_DEMANDE: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_GELCOM":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_GELCOM: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_TRAVAUX_SECTEUR":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_TRAVAUX_SECTEUR: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_TRAVAUX_RUE":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_TRAVAUX_RUE: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      case "IMB_BLOC_COLLECTIF_TIERS":
        setOptionSelectedConfigCarte({
          ...optionSelectedConfigCarte,
          IMB_BLOC_COLLECTIF_TIERS: e.target.checked,
          ALL_STATUSES: false,
          FTTE: false,
        });
        break;
      default:
    }
  };

  /**
   * Gère l'affichage conditionnel des champs du formulaire
   * @param {string} value La valeur renseignée par l'utilisateur
   * @param {string} fieldName Le champ modifié par l'utilisateur
   */
  const switchDisplayField = (value, fieldName) => {
    if (fieldName === "IMBCodeImmeuble") {
      if (value !== "") {
        setDisplayAdresse(false);
        setDisableHexacleField(true);
        setDisableLatLongField(true);
        setDisableSIRETField(true);
        setDisableSearchButton(false);
      } else {
        setDisplayAdresse(true);
        setDisableHexacleField(false);
        setDisableLatLongField(false);
        setDisableSIRETField(false);
        setDisableSearchButton(true);
      }
    } else if (fieldName === "IMBHexacle") {
      if (value !== "") {
        setDisplayAdresse(false);
        setDisableIMBField(true);
        setDisableLatLongField(true);
        setDisableSIRETField(true);
        setDisableSearchButton(false);
      } else {
        setDisplayAdresse(true);
        setDisableIMBField(false);
        setDisableLatLongField(false);
        setDisableSIRETField(false);
        setDisableSearchButton(true);
      }
    } else if (fieldName === "FTTE") {
      if (value !== "") {
        setDisplayAdresse(false);
        setDisableHexacleField(true);
        setDisableIMBField(true);
        setDisableLatLongField(true);
        setDisableSearchButton(false);
      } else {
        setDisplayAdresse(true);
        setDisableHexacleField(false);
        setDisableIMBField(false);
        setDisableLatLongField(false);
        setDisableSearchButton(true);
      }
    } else if (fieldName === "LAT" || fieldName === "LONG") {
      if ((fieldName === "LAT" && value === "") || (fieldName === "LONG" && value === "")) {
        setDisableSearchButton(true);
      } else if (value !== "") {
        setDisplayAdresse(false);
        setDisableIMBField(true);
        setDisableHexacleField(true);
        setDisableSIRETField(true);
      }
      if (
        (fieldName === "LAT" && value === "" && (valueLONG == null || valueLONG === "")) ||
        (fieldName === "LONG" && value === "" && (valueLAT == null || valueLAT === ""))
      ) {
        setDisplayAdresse(true);
        setDisableIMBField(false);
        setDisableHexacleField(false);
        setDisableSIRETField(false);
        setDisableSearchButton(true);
      }
    } else if (fieldName === "commune") {
      if (value !== "" && value !== null) {
        setDisplaySpecific(false);
      } else {
        setDisplaySpecific(true);
      }
    }

    if (
      (value !== "" && fieldName === "LAT" && valueLONG != null && valueLONG !== "") ||
      (value !== "" && fieldName === "LONG" && valueLAT != null && valueLAT !== "")
    ) {
      setDisableSearchButton(false);
    }
  };

  /**
   * Reset les states des résultats de recherche
   */
  const resultReset = () => {
    setListeImmeublesParAdresse([]);
    setInfoImmeuble(null);
    setDisplayRecherche(true);
    setInfoEligPro(null);
    setDisplayNoResultat(false);
    setSelectedRow(-1);
    setPositionMarkerTarget(null);
    setProspectSent(false);
    setDisplayProspect(false);
    setProspectInitialValues(null);
  };

  /**
   * Reset les states de résultats de recherche d'un immeuble
   */
  const infoImmeubleReset = () => {
    setInfoImmeuble(null);
    setDisplayRecherche(true);
    setPositionMarkerTarget(null);
  };

  /**
   * Reset tous les champs du formulaire
   */
  const resetMyForm = () => {
    setValueCommune(null);
    setValueVoie(null);
    setValueNumero(null);
    setValueLAT(null);
    setValueLONG(null);
    setInfoEligPro(null);
    setDisplayAdresse(true);
    setDisplaySpecific(true);
    setDisableIMBField(false);
    setDisableHexacleField(false);
    setDisableLatLongField(false);
    setDisableSIRETField(false);
    setDisableVoie(true);
    setDisableNumero(true);
    setDisableSearchButton(true);
    setCodeInsee(null);
  };

  /**
   * Récupère la liste des communes de marchés par leurs codes réseau
   * @param {array} codesReseau Les codes réseau des marchés
   */
  const getCommunesOfMarches = codesReseau => {
    Commune.getCommunesByCodesReseau(codesReseau, abortInit).then(response => {
      setCommuneList(response);
      setIsSearching(false);
    });
  };

  /**
   *  Récupère la liste des voies d'une commune suivant son code Insee & code postal
   * @param {number} inseeCode Le code Insee
   * @param {number} codePostal Le code Postal
   */
  const getVoiesParCommune = (inseeCode, codePostal) => {
    abortVoies.abort();
    const abort = new AbortController();
    setAbortVoies(abort);

    Commune.getVoiesOfCommune(inseeCode, codePostal, abort)
      .then(response => {
        const voiesTemp = sortBy(response, ["libelleVoie"]);
        setVoiesList(voiesTemp);
      })
      .finally(() => {
        setDisableVoie(false);
      });
  };

  /**
   * Récupère les informations géographiques de la rue
   * @param {string} voie La rue de la commune
   * @param {number} postCode Le code postal de la commune
   * @param {string} nomCommune Le nom de la commune
   */
  const getGeoLocalisationVoie = (voie, postCode, nomCommune) => {
    const adresse = `${voie} ${nomCommune} , FRANCE`;
    GeoCodage.getGeoCodageVoie(adresse, postCode).then(response => {
      if (response.features.length > 0) {
        const targetPostion = [
          response.features[0].geometry.coordinates[1],
          response.features[0].geometry.coordinates[0],
        ];
        mapRef.current.leafletElement.setView(targetPostion, 17);
        setPositionMarkerTarget(targetPostion);
      }
    });
  };

  /**
   * Récupère la liste des numéros d'une voie
   * @param {string} referenceVoieOI
   * @param {string} libelleVoieOI
   * @param {number} communeCodeInsee
   */
  const getNumeroParVoie = ({ referenceVoieOI, libelleVoieOI, communeCodeInsee }) => {
    abortNumeros.abort();
    const abort = new AbortController();
    setAbortNumeros(abort);

    Commune.getNumerosOfVoie({ referenceVoieOI, libelleVoieOI, codeInsee: communeCodeInsee, abort })
      .then(response => {
        const numerosTemp = sortBy(response, ["numeroVoie", "complementNumeroVoie"]);
        setNumerosList(numerosTemp);
      })
      .finally(() => {
        setDisableNumero(false);
      });
  };

  /**
   * Récupère les informations d'un immeuble
   * @param {string} codeIMB Le code de l'immeuble
   */
  const rechercheInfoIMB = codeIMB => {
    abortInfosImb.abort();
    const abort = new AbortController();
    setAbortInfosImb(abort);

    Immeuble.getImbInfos(codeIMB, abort)
      .then(responseIMB => {
        const immeubleInfo = creationImmeuble(responseIMB[0]);
        const targetPosition = [responseIMB[0].latitude, responseIMB[0].longitude];

        setMapViewOnTarget(targetPosition);
        setPositionMarkerTarget(targetPosition);
        setInfoImmeuble(immeubleInfo);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
  };

  /**
   * Recherche un immeuble suivant un code IMB donné
   * @param {string} codeIMB Le code IMB de l'immeuble
   * @param {boolean} isImbInit Si la recherche de l'immeuble se fait à l'initialisation
   */
  const rechercheParIMB = (codeIMB, isImbInit = false) => {
    abortInfosImb.abort();
    const abort = new AbortController();
    setAbortInfosImb(abort);

    Immeuble.getImbInfos(codeIMB, abort)
      .then(responseIMB => {
        if (
          responseIMB.length > 0 &&
          marcheList.some(code => code.codeReseau === responseIMB[0].codeReseau)
        ) {
          setDisplayRecherche(false);
          const immeubleInfo = creationImmeuble(responseIMB[0]);
          const targetPosition = [responseIMB[0].latitude, responseIMB[0].longitude];

          setMapViewOnTarget(targetPosition);
          setPositionMarkerTarget(targetPosition);

          setListeImmeublesParAdresse([immeubleInfo]);
          setInfoImmeuble(immeubleInfo);

          setImbWkt({
            minLatLng: mapRef.current.leafletElement.getBounds().getSouthWest(),
            maxLatLng: mapRef.current.leafletElement.getBounds().getNorthEast(),
          });
        } else {
          setDisplayNoResultat(true);
          isImbInit && setResetCoordonees(!resetCoordonnees);
        }
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      })
      .finally(() => {
        setIsSearching(false);
      });
  };

  /**
   * Recherche une liste d'immeubles suivant un hexaclé donné
   * @param {string} refHexacle La référence de l'hexaclé
   * @param {string} typeRecherche Le type de recherche effectuée (Par hexaclé ou par adresse)
   */
  const rechercheParHexacle = (refHexacle, typeRecherche) => {
    setIsSearching(true);

    abortInfosImb.abort();
    const abort = new AbortController();
    setAbortInfosImb(abort);

    Immeuble.getImbInfosByHexacle(refHexacle, abort)
      .then(responseIMB => {
        const listeImmeuble = responseIMB
          .filter(itemIMB => marcheList.some(item => item.codeReseau === itemIMB.codeReseau))
          .map(itemIMB => creationImmeuble(itemIMB));

        if (listeImmeuble.length > 0) {
          setDisplayRecherche(false);
          const tempCodeINSEE = responseIMB[0].codeINSEE;
          const targetPosition = [responseIMB[0].latitude, responseIMB[0].longitude];
          setListeImmeublesParAdresse(listeImmeuble);

          if (listeImmeuble.length === 1) {
            setInfoImmeuble(listeImmeuble[0]);
            setPositionMarkerTarget(targetPosition);
            setMapViewOnTarget(targetPosition);
          }
          if (listeImmeuble.length > 1) {
            // Si la recherche provient d'une recherche spécifique par hexaclé on centre sur la commune avec les contours puis sur la voie
            if (typeRecherche === "hexacle") {
              setCodeInsee(tempCodeINSEE);
              setProspectInitialValues(null);
              getGeoLocalisationVoie(
                listeImmeuble[0].voieAdresse,
                listeImmeuble[0].codePostal,
                listeImmeuble[0].libelleCommune,
              );
            }
          }
        } else {
          setDisplayNoResultat(true);
        }
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      })
      .finally(() => {
        setIsSearching(false);
      });
  };

  /**
   * Recherche l'éligibilité Pro d'un immeuble suivant son SIRET
   * @param {string} siret Le SIRET de l'entreprise
   * @param {number} lat La longitude du marker
   * @param {number} lng La latitude du marker
   */
  const rechercheParSiret = (siret, lat, lng) => {
    setIsSearching(true);
    handleDrawerLeftOpen("openSearch");

    let eligProLibelleMarche = "";
    let eligProResultZone = "";
    let eligProResultContacts = [];
    let message = "";
    let pointEligible = false;

    abortEligPro.abort();
    const abort = new AbortController();
    setAbortEligPro(abort);

    EligibilitePro.getEligibiliteProSiretMux(siret, abort)
      .then(async responseElig => {
        const { zoneElig, codeReseau } = responseElig.features[0].properties;

        // On test si le point est éligible
        if (zoneElig !== "AI0" && zoneElig !== "AI1" && zoneElig !== "AI2") {
          pointEligible = false;
          eligProResultZone = "AI3";
          message = "Sur devis";
        } else {
          pointEligible = true;
          eligProResultZone = zoneElig;

          // Vérifie que le point testé appartient au marché en cours
          message = marcheList.some(marche => marche.codeReseau === codeReseau)
            ? "Eligible"
            : "Eligible mais point hors du marché";
        }

        // On map les infos sur le marché et les contacts si présents dans un marché
        marcheList.forEach(marche => {
          if (marche.codeReseau === codeReseau) {
            eligProResultContacts = marche.marContacts;
            eligProLibelleMarche = marche.libelle;
          }
        });

        const infoEligMux = {
          siret: siret,
          siretLat: lat,
          siretLong: lng,
          resultat: pointEligible,
          codeReseau: codeReseau,
          libelleMarche: eligProLibelleMarche,
          pointTestLat: "",
          pointTestLng: "",
          pointFibreLat: parseFloat(responseElig.features[0].geometry.coordinates[1]).toFixed(6),
          pointFibreLng: parseFloat(responseElig.features[0].geometry.coordinates[0]).toFixed(6),
          distance: responseElig.features[0].properties.distance,
          MessageRes: message,
          zone: eligProResultZone,
          commercial: {
            email: "cotation@altitudeinfra.fr",
          },
          contacts: eligProResultContacts,
        };

        setDisplayRecherche(false);
        setInfoEligPro(infoEligMux);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      })
      .finally(() => setIsSearching(false));
  };

  /**
   * Recherche une éligibilité pro par latitude et longitude
   * @param {number} lat La latitude renseignée
   * @param {number} long La longitude renseignée
   */
  const rechercheParLatLong = (lat, long) => {
    setIsSearching(true);
    handleDrawerLeftOpen("openSearch");

    let eligProLibelleMarche = "";
    let eligProResultZone = "";
    let eligProResultContacts = [];
    const targetPosition = [lat, long];
    let message = "";
    let pointEligible = false;

    abortEligPro.abort();
    const abort = new AbortController();
    setAbortEligPro(abort);

    EligibilitePro.getEligibiliteProMux(lat, long, abort)
      .then(async responseElig => {
        const { zoneElig, codeReseau } = responseElig.features[0].properties;

        // On test si le point est éligible
        if (zoneElig !== "AI0" && zoneElig !== "AI1" && zoneElig !== "AI2") {
          pointEligible = false;
          eligProResultZone = "AI3";
          message = "Sur devis";
        } else {
          pointEligible = true;
          eligProResultZone = zoneElig;

          // Vérifie que le point testé appartient au marché en cours
          message = marcheList.some(marche => marche.codeReseau === codeReseau)
            ? "Eligible"
            : "Eligible mais point hors du marché";
        }

        // On map les infos sur le marché et les contacts si présents dans un marché
        marcheList.forEach(marche => {
          if (marche.codeReseau === codeReseau) {
            eligProResultContacts = marche.marContacts;
            eligProLibelleMarche = marche.libelle;
          }
        });

        const infoEligMux = {
          siret: "",
          siretLat: "",
          siretLong: "",
          resultat: pointEligible,
          codeReseau: codeReseau,
          libelleMarche: eligProLibelleMarche,
          pointTestLat: parseFloat(lat).toFixed(6),
          pointTestLng: parseFloat(long).toFixed(6),

          pointFibreLat: parseFloat(responseElig.features[0].geometry.coordinates[1]).toFixed(6),
          pointFibreLng: parseFloat(responseElig.features[0].geometry.coordinates[0]).toFixed(6),
          distance: responseElig.features[0].properties.distance,
          MessageRes: message,
          zone: eligProResultZone,
          commercial: {
            email: "cotation@altitudeinfra.fr",
          },
          contacts: eligProResultContacts,
        };

        setDisplayRecherche(false);
        setInfoEligPro(infoEligMux);

        setPositionMarkerTarget(targetPosition);
        setMapViewOnTarget(targetPosition);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      })
      .finally(() => setIsSearching(false));
  };

  /**
   * Formate les données d'un immeuble
   * @param {Object} IMB Un objet représentant un immeuble
   * @returns {Object} L'immeuble formaté
   */
  const creationImmeuble = IMB => {
    let statutElig = "";
    let classColorElig = "";
    const gelCommercial = IMB.gelCommercial === "1";
    const typeIMB = IMB.typeBatiment === "I" ? "Immeuble" : "Pavillon";

    /* Prise en compte IMB en gel commercial pour motif particulier */
    if (gelCommercial) {
      statutElig = "Correction technique en cours";
      classColorElig = "tableSelectedProchainementEligible";
    } else if (IMB.statutEligibilite === "RA") {
      classColorElig = "tableSelectedEligible";

      if (dsp.codeReseau !== "AI-DOUB") {
        statutElig = "Raccordé";
      } else {
        // overwrite statutEligibilite for DOUBS
        // eslint-disable-next-line no-param-reassign
        IMB.statutEligibilite = "DE";
        statutElig = "Eligible";
      }
    } else if (IMB.statutEligibilite === "DE") {
      statutElig = "Eligible";
      classColorElig = "tableSelectedEligible";
    } else if (IMB.statutEligibilite === "GE") {
      statutElig = "Prochainement éligible";
      classColorElig = "tableSelectedProchainementEligible";
    } else if (IMB.statutEligibilite === "EC" && dsp.codeReseau === "AI-VENU") {
      if (IMB.statutSRO === "DEPLOYE" && IMB.NB_IMBPBO > 0) {
        statutElig = "Travaux en cours dans votre rue";
      } else if (IMB.statutSRO === "DEPLOYE") {
        statutElig = "Travaux en cours dans votre secteur";
      } else {
        // Fallback
        statutElig = "En cours d'étude";
      }
      classColorElig = "tableSelectedNonEligible";
    } else if (IMB.statutEligibilite === "RDEC") {
      statutElig = "RAD en cours de déploiement";
      classColorElig = "tableSelectedSurDemande";
    } else if (IMB.statutEligibilite === "RD") {
      statutElig = "Raccordable sur demande";
      classColorElig = "tableSelectedSurDemande";
    } else if (IMB.statutEligibilite === "AB") {
      statutElig = "Abandonné";
      classColorElig = "tableSelectedNonEligible";
    } else {
      // Valable pour : EC / SI / CI / ET
      statutElig = "En cours d'étude";
      classColorElig = "tableSelectedNonEligible";
    }

    setProspectInitialValues({
      nomBatiment: IMB.nomBatiment,
      numeroAdresse: `${IMB.numeroAdresse}${IMB.extensionAdresse}`,
      voieAdresse: IMB.voieAdresse,
      codePostal: IMB.codePostal,
      libelleCommune: IMB.libelleCommune,
      imb: IMB.referenceIMB,
      latitude: IMB.latitude,
      longitude: IMB.longitude,
      resultat: statutElig,
      marche: marcheList.find(marche => marche.codeReseau === IMB.codeReseau).libelle,
      civilite: "",
      nom: "",
      prenom: "",
      entreprise: "",
      email: "",
      fixe: "",
      mobile: "",
      rgpd: false,
    });

    return {
      referenceIMB: IMB.referenceIMB,
      nomBatiment: IMB.nomBatiment,
      numeroAdresse: IMB.numeroAdresse,
      extensionAdresse: IMB.extensionAdresse,
      voieAdresse: IMB.voieAdresse,
      codePostal: IMB.codePostal,
      codeINSEE: IMB.codeINSEE,
      libelleCommune: IMB.libelleCommune,
      hexacle: IMB.hexacle,
      typeBatiment: typeIMB,
      typeClient: IMB.typeClient,
      MARCHE: IMB.MARCHE,
      codeReseau: IMB.codeReseau,
      dateMESCommercialeIMB: IMB.dateMESCommercialeIMB,
      referencePBO: IMB.referencePBO,
      referenceSRO: IMB.referenceSRO,
      NROImmeuble: IMB.referenceNRO,
      statut: IMB.statut,
      statutEligImmeubleTxt: statutElig,
      statutEligImmeuble: IMB.statutEligibilite,
      classColorElig: classColorElig,
      gelCommercial: gelCommercial,
      motifGelCommercial: IMB.motifGelCommercial,
      dateDebutGelCommercial: IMB.dateDebutGelCommercial,
      dateFinGelCommercial: IMB.dateFinGelCommercial,
      commentaire: IMB.commentaire,
      technoIMB: IMB.technoIMB,
      nbreLogementImmeuble: IMB.nombrePrises,
      raccoLong: IMB.raccoLong,
      latImmeuble: IMB.latitude,
      longImmeuble: IMB.longitude,
      raccoBatiment: IMB.raccoBatiment,
      modePosePBO: IMB.modePosePBO,
    };
  };

  /**
   * Affiche ou cache les immeubles
   */
  const handleIMBDisplay = () => {
    if (displayMarkerImb) {
      setDisplayMarkerImb(false);
    } else {
      const minLatLngTemp = mapRef.current.leafletElement.getBounds().getSouthWest();
      const maxLatLngTemp = mapRef.current.leafletElement.getBounds().getNorthEast();

      if (
        imbWkt.minLatLng.lat !== minLatLngTemp.lat ||
        imbWkt.minLatLng.lng !== minLatLngTemp.lng ||
        imbWkt.maxLatLng.lat !== maxLatLngTemp.lat ||
        imbWkt.maxLatLng.lng !== maxLatLngTemp.lng
      ) {
        setImbWkt({
          minLatLng: minLatLngTemp,
          maxLatLng: maxLatLngTemp,
        });
      }

      setDisplayMarkerImb(true);
    }
  };

  /**
   * Affiche les immeubles ou les zones NRO/SRO suivant le niveau de zoom
   * @param {HTMLElement} e la carto Leaflet
   */
  const onZoomOrDrag = async e => {
    mapRef.current.leafletElement.invalidateSize();
    if (isAutoPanning) {
      setIsAutoPanning(false);
    } else {
      const item = e.target;

      if (
        displayMarkerImb &&
        item.getZoom() >= ZOOM_LEVEL_IMB &&
        (optionSelectedConfigCarte.IMB_DEMANDE ||
          optionSelectedConfigCarte.IMB_ELIG ||
          optionSelectedConfigCarte.IMB_ETUDE ||
          optionSelectedConfigCarte.IMB_TRAVAUX_SECTEUR ||
          optionSelectedConfigCarte.IMB_TRAVAUX_RUE ||
          optionSelectedConfigCarte.IMB_PROELIG ||
          optionSelectedConfigCarte.IMB_GELCOM ||
          optionSelectedConfigCarte.IMB_RAC)
      ) {
        setChargementIMBWtk(true);
        setImbWkt({
          minLatLng: item.getBounds().getSouthWest(),
          maxLatLng: item.getBounds().getNorthEast(),
        });
      } else if (
        displayMarkerImb &&
        item.getZoom() >= ZOOM_LEVEL_FTTE &&
        optionSelectedConfigCarte.FTTE
      ) {
        setChargementIMBWtk(true);
        setImbWkt({
          minLatLng: item.getBounds().getSouthWest(),
          maxLatLng: item.getBounds().getNorthEast(),
        });
      } else {
        setChargementIMBWtk(false);
      }
    }
  };

  /**
   * Récupére les informations de l'immeuble au clic sur un marqueur
   * @param {Object} IMB La référenceImb de l'immeuble
   * @param {*} position La position du marqueur
   * @param {*} technoIMB Le type d'immeuble
   */
  const onMarkerImbClick = async (IMB, position, technoIMB) => {
    await resultReset();
    if (technoIMB === "FTTH" || technoIMB === "FTTE") {
      setIsSearching(true);

      abortInfosImb.abort();
      const abort = new AbortController();
      setAbortInfosImb(abort);

      Immeuble.getImbInfos(IMB, abort)
        .then(responseIMB => {
          const immeubleInfo = creationImmeuble(responseIMB[0]);
          setListeImmeublesParAdresse(immeubleInfo);
          setInfoImmeuble(immeubleInfo);

          setDisplayRecherche(false);
          handleDrawerLeftOpen("openSearch");

          setPositionMarkerTarget(position);
          // );
        })
        .catch(e => {
          if (e.code !== "ERR_CANCELED") {
            enqueueSnackbar(process.env.ERREUR_SERVEUR, {
              variant: "error",
              autoHideDuration: 6000,
            });
          }
        })
        .finally(() => setIsSearching(false));
    }
  };

  const onOperatorPopupClick = async ({
    nomBatiment,
    numeroAdresse,
    voieAdresse,
    codePostal,
    libelleCommune,
    imb,
    latitude,
    longitude,
    resultat,
    codeReseau,
  }) => {
    await resultReset();
    setProspectInitialValues({
      nomBatiment: nomBatiment,
      numeroAdresse: numeroAdresse,
      voieAdresse: voieAdresse,
      codePostal: codePostal,
      libelleCommune: libelleCommune,
      imb: imb,
      latitude: latitude,
      longitude: longitude,
      resultat: resultat,
      marche: marcheList.find(marche => marche.codeReseau === codeReseau).libelle,
      civilite: "",
      nom: "",
      prenom: "",
      entreprise: "",
      email: "",
      fixe: "",
      mobile: "",
      rgpd: false,
    });

    setDisplayRecherche(false);
    setDisplayProspect(true);
    handleDrawerLeftOpen("openSearch");
  };

  /**
   * Change le layer de la carto
   */
  const handleLayerChange = () => {
    if (urlLayer === LAYER_OSM) {
      setUrlLayer(LAYER_GOOGLE);
      setTooltip("Passer en vue plan");
      setImageButton(<MapTwoTone className="IconMap" fontSize="large" />);
      setOptionSelectedConfigCarte({
        ...optionSelectedConfigCarte,
        LAYER_PLAN: false,
        LAYER_SAT: true,
      });
    }
    if (urlLayer === LAYER_GOOGLE) {
      setUrlLayer(LAYER_OSM);
      setTooltip("Passer en vue satellite");
      setImageButton(<SatelliteTwoTone className="IconSatellite" fontSize="large" />);
      setOptionSelectedConfigCarte({
        ...optionSelectedConfigCarte,
        LAYER_PLAN: true,
        LAYER_SAT: false,
      });
    }
  };

  /**
   * Zoom sur la carte
   */
  const zoomIn = () => {
    zoom < MAX_ZOOM_MAP &&
      mapRef.current.leafletElement.setView(
        L.latLng(
          mapRef.current.leafletElement.getBounds().getCenter().lat,
          mapRef.current.leafletElement.getBounds().getCenter().lng,
        ),
        zoom + 1,
      );
  };

  /**
   * Dézoom sur la carte
   */
  const zoomOut = () => {
    zoom > MIN_ZOOM_MAP &&
      mapRef.current.leafletElement.setView(
        L.latLng(
          mapRef.current.leafletElement.getBounds().getCenter().lat,
          mapRef.current.leafletElement.getBounds().getCenter().lng,
        ),
        zoom - 1,
      );
  };

  /**
   * Recalcule la taille de la carte Leaflet suivant la modification du Viewport
   */
  const handleChangeViewPort = async () => {
    if (mapRef.current !== null) {
      mapRef.current.leafletElement.invalidateSize();
    }
  };

  /**
   * Centre la vue de la carte sur une cible
   * @param {Array} targetPosition Un array de position leaflet
   */
  const setMapViewOnTarget = targetPosition => {
    mapRef.current.leafletElement.setView(targetPosition, 18);
  };

  /**
   * Reset la vue de la carte
   * @param {array} target Un array Bounds de leaflet
   */
  const resetMapView = async target => {
    await mapRef.current.leafletElement.fitBounds(target);
    setPositionMarkerTarget(null);
  };

  /**
   * Force la map à avoir la même taille que la fenêtre
   */
  const reportWindowSize = async () => {
    setVisibleHeight(window.innerHeight);
    setCurrentWidth(window.innerWidth);
    setIsMobileLandscape(isMobile && window.innerHeight <= window.innerWidth);
  };

  /**
   * Géolocalise l'utilisateur s'il a donné les permissions d'accès à sa position
   * @param {array} pos Les coordonnées de l'utilisateur
   */
  const onGeolocationSuccess = pos => {
    const targetPosition = [pos.coords.latitude, pos.coords.longitude];

    setPositionMarkerTarget(targetPosition);
    setMapViewOnTarget(targetPosition);
    setIsLoading(false);
  };

  /**
   * Génère un message d'erreur lorsqu'il est impossible de récupérer la position de l'utilisateur
   * @param {number} err le code erreur remonté par le navigateur
   */
  const onGeolocationError = err => {
    setIsLoading(false);
    let errMessage = "";

    switch (err.code) {
      case 1:
        errMessage = "Veuillez autoriser le navigateur à récupérer votre géolocalisation";
        break;
      case 2:
        errMessage = "Votre position n'a pas pu être récupérée";
        break;
      case 3:
        errMessage = "Le navigateur n'a pas pu récupérer votre position dans le temps imparti";
        break;
      default:
    }

    enqueueSnackbar(errMessage, {
      variant: "error",
      autoHideDuration: 6000,
    });
  };

  /**
   * Géolocalise l'utilisateur suivant ses coordonnées GPS ou celles du navigateur
   */
  const geolocalizeUser = () => {
    setIsLoading(true);
    navigator.geolocation.getCurrentPosition(onGeolocationSuccess, onGeolocationError, {
      enableHighAccuracy: true,
      timeout: 30000,
      maximumAge: 0,
    });
  };

  /**
   * Récupère le marché renseigné en paramètre url et la date de MAJ des informations de la carto
   */
  const recuperationData = async () => {
    Version.getDateMaj(abortInit)
      .then(dateMaj => {
        setDateVersion(dateMaj);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });

    /*
    Marche.getMarchesByCodesReseau([dsp.codeReseau, ...dsp.secondaryMarches], abortInit)
      .then(marches => {

        const listMarche = marches.map(item => ({
          marId: item.id,
          marCode: item.code,
          codeReseau: item.codeReseau,
          marTypeForme: item.typeForme,
          libelle: item.libelle,
          marDateGenIpe: item.dateGenIpe,
          marDateGenCpn: item.dateGenCpn,
          marCodeCouleur: item.codeCouleur,
          marPrefixFtth: item.prefixFtth,
          marBaseNetgeo: item.baseNetGeo,
          marCodeOiInterop: item.codeOiInterop,
          marUrl: item.url,
          marDateArchive: item.dateArchive,
          marContacts: item.contacts,
        }));

        setMarcheList(listMarche);
        setValueMarche(listMarche.find(marche => marche.codeReseau === dsp.codeReseau));

      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
    */

    const listMarche = [dsp, ...dsp.secondaryMarches];
    setMarcheList(listMarche);
    setValueMarche(dsp);
    getCommunesOfMarches(listMarche.map(marche => marche.codeReseau));
  };

  useEffect(() => {
    setTooltipImbDisplay(
      (zoom >= ZOOM_LEVEL_FTTE && optionSelectedConfigCarte.FTTE) ||
        (zoom >= ZOOM_LEVEL_IMB &&
          (optionSelectedConfigCarte.IMB_DEMANDE ||
            optionSelectedConfigCarte.IMB_ELIG ||
            optionSelectedConfigCarte.IMB_ETUDE ||
            optionSelectedConfigCarte.IMB_TRAVAUX_SECTEUR ||
            optionSelectedConfigCarte.IMB_TRAVAUX_RUE ||
            optionSelectedConfigCarte.IMB_PROELIG ||
            optionSelectedConfigCarte.IMB_GELCOM ||
            optionSelectedConfigCarte.IMB_RAC)),
    );
  }, [zoom, optionSelectedConfigCarte]);

  useEffect(() => {
    if (
      [isLoadingZaMarche, isLoadingZaSro, isLoadingZaAmiiVN, isLoadingZaRadioVN].every(
        e => e === false,
      )
    ) {
      setIsInit(false);
      setIsLoading(false);
    }
  }, [isLoadingZaMarche, isLoadingZaSro, isLoadingZaAmiiVN, isLoadingZaRadioVN]);

  useEffect(() => {
    if (!isEmpty(marcheList) && params.has("referenceImb")) {
      rechercheParIMB(params.get("referenceImb"), true);
    }
  }, [marcheList]);

  useEffect(() => {
    const reportMapSizeChange = new ResizeObserver(async () => {
      mapRef.current.leafletElement.invalidateSize();
    });

    window.addEventListener("resize", reportWindowSize);
    window.dispatchEvent(new Event("resize"));
    reportMapSizeChange.observe(mapContainerRef.current);

    recuperationData();

    return () => {
      abortInit.abort();
      abortInfosImb.abort();
      abortEligPro.abort();
    };
  }, []);

  return (
    <>
      <div className="buttonsWrapperCarteElig" {...swipeHandler}>
        <Tooltip
          PopperProps={{ container: () => document.querySelector("#root") }}
          title={
            (openSearch || openSetting) && window.innerWidth <= 992 ? (
              ""
            ) : (
              <Typography variant={window.innerWidth >= 600 ? "body1" : "body2"} component="div">
                <Grid container spacing={1}>
                  <Grid container item xs={12} className="tooltip-help-menu">
                    <Grid item xs={12} className="container-close-menu">
                      <MuiThemeProvider theme={ButtonClose}>
                        <Button
                          classes={{ root: "close-menu" }}
                          startIcon={<Clear />}
                          onClick={() => setIsOpenTooltipHelper(false)}
                        />
                      </MuiThemeProvider>
                    </Grid>
                    <Grid item xs={12}>
                      <span>Tester votre éligibilité en :</span>
                    </Grid>
                    <Grid container item xs={12} alignItems="center">
                      <MyLocationTwoTone className="popper-icon" />
                      <span>vous géolocalisant</span>
                    </Grid>
                    <Grid container item xs={12} alignItems="center">
                      <SearchTwoTone className="popper-icon" />
                      <span>sélectionnant votre adresse</span>
                    </Grid>
                    <Grid container item xs={12} alignItems="center">
                      {isMobile ? (
                        <TouchAppTwoTone className="popper-icon" />
                      ) : (
                        <MouseTwoTone className="popper-icon" />
                      )}
                      <span>navigant sur la carte</span>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12}>
                      <span>Votre adresse n&apos;est pas référencée ?</span>
                    </Grid>
                    <Grid container item xs={12} alignItems="center">
                      <AddLocationTwoTone className="popper-icon" />
                      <span>Ajouter votre adresse</span>
                    </Grid>
                  </Grid>
                </Grid>
              </Typography>
            )
          }
          open={isOpenTooltipHelper}
          placement="left"
          interactive
          arrow
          disableHoverListener
          disableFocusListener
        >
          <div className={openMenu ? "menu-container menu-open" : "menu-container"}>
            <MuiThemeProvider theme={MenuIconsTheme}>
              <div className="menu-button">
                <Tooltip
                  title={<Typography>{openMenu ? "Fermer" : "Ouvrir"} le menu</Typography>}
                  placement="left"
                  arrow
                >
                  <Button onClick={() => setOpenMenu(!openMenu)}>Menu</Button>
                </Tooltip>
              </div>
              <div className="button-container">
                <div className="menu-btn-zoom">
                  <Tooltip
                    title={<Typography>{tooltipHelp(isOpenTooltipHelper)}</Typography>}
                    placement="left"
                    arrow
                  >
                    <Button
                      className="menu-btn"
                      onClick={() => setIsOpenTooltipHelper(!isOpenTooltipHelper)}
                    >
                      <HelpOutlineTwoTone
                        className={isOpenTooltipHelper ? "iconeActive" : ""}
                        fontSize="large"
                      />
                    </Button>
                  </Tooltip>
                  <Tooltip title={<Typography>{tooltipZoomIn}</Typography>} placement="left" arrow>
                    <Button className="menu-btn" onClick={zoomIn}>
                      <ZoomInTwoTone fontSize="large" />
                    </Button>
                  </Tooltip>
                  <Tooltip title={<Typography>{tooltipZoomOut}</Typography>} placement="left" arrow>
                    <Button className="menu-btn" onClick={zoomOut}>
                      <ZoomOutTwoTone fontSize="large" />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    title={<Typography>{tooltipResetMapZoom}</Typography>}
                    placement="left"
                    arrow
                  >
                    <Button
                      className="menu-btn"
                      onClick={() => setResetCoordonees(!resetCoordonnees)}
                    >
                      <ZoomOutMapTwoTone fontSize="large" />
                    </Button>
                  </Tooltip>
                  <Tooltip title={<Typography>{tooltip}</Typography>} placement="left" arrow>
                    <Button className="menu-btn" onClick={handleLayerChange}>
                      {imageButton}
                    </Button>
                  </Tooltip>
                  <Tooltip title={<Typography>{tooltipGeoloc}</Typography>} placement="left" arrow>
                    <Button className="menu-btn menu-btn-geo" onClick={geolocalizeUser}>
                      <MyLocationTwoTone fontSize="large" />
                    </Button>
                  </Tooltip>
                </div>
                <div className="menu-btn-config">
                  <Tooltip title={<Typography>{tooltipSearch}</Typography>} placement="left" arrow>
                    <Button
                      className="menu-btn"
                      onClick={() => handleDrawerLeftOpen(!openSearch && "openSearch")}
                    >
                      <SearchTwoTone className={openSearch ? "iconeActive" : ""} fontSize="large" />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    title={<Typography>{tooltipAddAdress}</Typography>}
                    placement="left"
                    arrow
                  >
                    <Button
                      className="menu-btn"
                      onClick={() =>
                        window.open(
                          `https://renseignementsfibre.altitudeinfra.fr/eligibilite/dsp/${dsp.codeMarche}`,
                          "_blank",
                          "rel=noreferrer",
                        )
                      }
                    >
                      <AddLocationTwoTone fontSize="large" />
                    </Button>
                  </Tooltip>
                  <Tooltip title={<Typography>{tooltipSetting}</Typography>} placement="left" arrow>
                    <Button
                      className="menu-btn"
                      onClick={() => handleDrawerLeftOpen(!openSetting && "openSetting")}
                    >
                      <BuildTwoTone className={openSetting ? "iconeActive" : ""} fontSize="large" />
                    </Button>
                  </Tooltip>
                  {tooltipImbDisplay && (
                    <Tooltip
                      title={<Typography>{tooltipImb(displayMarkerImb)}</Typography>}
                      placement="left"
                      arrow
                    >
                      <span>
                        <Button
                          className="menu-btn"
                          disabled={chargementIMBWtk}
                          onClick={handleIMBDisplay}
                        >
                          <HomeTwoTone
                            className={displayMarkerImb ? "iconeActive" : ""}
                            fontSize="large"
                          />
                        </Button>
                      </span>
                    </Tooltip>
                  )}
                  <Tooltip
                    title={<Typography>{tooltipHideLegende(displayLegende)}</Typography>}
                    placement="left"
                    arrow
                  >
                    <Button className="menu-btn" onClick={() => setDisplayLegende(!displayLegende)}>
                      <LabelOffTwoTone
                        className={displayLegende ? "iconeActive" : ""}
                        fontSize="large"
                      />
                    </Button>
                  </Tooltip>
                </div>
              </div>
            </MuiThemeProvider>
          </div>
        </Tooltip>
      </div>
      {/* Affichage drawer Recherche */}
      <MuiThemeProvider
        theme={openSearch ? DrawerEligibiliteSearchTheme : DrawerEligibiliteSearchThemeClosed}
      >
        <Drawer anchor="left" variant="persistent" open={openSearch}>
          <Spinner isLoading={isSearching} message="" small>
            <div className="divSearchMenu">
              <Paper elevation={3} className="paperSearch">
                <div className="alignCenter drawerHeader">
                  <a href={dsp.urlSite} target="_blank" rel="noreferrer">
                    {setLogoFromDsp(dsp)}
                  </a>
                  <div className="container-close">
                    <MuiThemeProvider theme={ButtonClose}>
                      <Button
                        classes={{ root: "annulButtonFormElig" }}
                        startIcon={<Clear />}
                        onClick={handleDrawerLeftOpen}
                      />
                    </MuiThemeProvider>
                  </div>
                </div>
              </Paper>
              <Paper elevation={3} className="paperSearch">
                <div className="titre">
                  <span>Recherche par adresse</span>{" "}
                  <IconButton
                    aria-label={displayRecherche ? "Fermer" : "Ouvrir"}
                    disableRipple
                    disableFocusRipple
                    className="toggleAccordionButton"
                    onClick={() => setDisplayRecherche(!displayRecherche)}
                  >
                    <DoubleArrow
                      classes={{
                        root: displayRecherche ? "accordion" : "accordion-close",
                      }}
                    />
                  </IconButton>
                </div>

                <div className={displayRecherche ? "visible" : "hidden"}>
                  <Formik
                    enableReinitialize
                    initialValues={{
                      IMBCodeImmeuble: "",
                      IMBHexacle: "",
                      LAT: "",
                      LONG: "",
                      SIRET: "",
                    }}
                    onReset={() => {
                      resetMyForm();
                      setResetCoordonees(!resetCoordonnees);
                    }}
                    onSubmit={async (values, { resetForm }) => {
                      setIsSearching(true);
                      await resultReset();
                      resetForm("");
                      setDisableSearchButton(true);

                      const { IMBCodeImmeuble, IMBHexacle, LAT, LONG, SIRET } = values;
                      if (IMBCodeImmeuble) {
                        resetMyForm();
                        rechercheParIMB(IMBCodeImmeuble);
                      } else if (IMBHexacle) {
                        resetMyForm();
                        rechercheParHexacle(IMBHexacle, "hexacle");
                        resetMyForm();
                      } else if (LAT && LONG) {
                        setIsSearching(true);
                        resetMyForm();
                        rechercheParLatLong(LAT, LONG);
                      } else if (SIRET) {
                        setIsSearching(true);
                        resetMyForm();
                        rechercheParSiret(SIRET);
                      } else {
                        setDisplayNoResultat(true);
                        setIsSearching(false);
                      }
                    }}
                    validationSchema={yup.object().shape({
                      IMBHexacle: yupHexacle,
                      LAT: yupLatLong,
                      LONG: yupLatLong,
                    })}
                    render={({ handleReset, setFieldValue }) => (
                      <Form className="globalFormElig expansionPanelForm">
                        <div className={displayAdresse ? "visible" : "hidden"}>
                          <Autocomplete
                            id="marche"
                            disabled
                            forcePopupIcon={false}
                            value={valueMarche}
                            options={marcheList}
                            getOptionLabel={option => option.libelle}
                            onChange={(e, item) => {
                              setValueMarche(item);
                              setValueCommune(null);
                              setValueVoie(null);
                              setValueNumero(null);
                              setDisableVoie(true);
                              setDisableNumero(true);
                            }}
                            renderInput={params => (
                              <TextField
                                {...params}
                                placeholder="Choisissez un marché"
                                variant="outlined"
                                fullWidth
                              />
                            )}
                          />
                          <Autocomplete
                            id="commune"
                            value={valueCommune}
                            options={communeList}
                            getOptionLabel={option =>
                              `${option.nomCommune} (${option.codePostal}) `
                            }
                            classes={{ root: "expansionPanelFormElig" }}
                            onChange={(e, item) => {
                              setValueCommune(item);
                              setDisableVoie(true);
                              setDisableNumero(true);
                              setValueVoie(null);
                              setValueNumero(null);
                              setFieldValue("IMBCodeImmeuble", "");
                              setDisableSearchButton(true);

                              if (item !== null) {
                                setCodeInsee(item.codeInsee);
                                getVoiesParCommune(item.codeInsee, item.codePostal);
                              } else {
                                setCodeInsee(null);
                              }
                              switchDisplayField(item, "commune");
                            }}
                            renderInput={params => (
                              <TextField
                                {...params}
                                placeholder="Choisissez une commune"
                                variant="outlined"
                                fullWidth
                              />
                            )}
                          />
                          <Autocomplete
                            id="voie"
                            disabled={disableVoie}
                            value={valueVoie}
                            options={voiesList}
                            getOptionLabel={option => option.libelleVoie}
                            classes={{ root: "expansionPanelFormElig" }}
                            onChange={(e, item) => {
                              if (item != null) {
                                getGeoLocalisationVoie(
                                  item.libelleVoie,
                                  valueCommune.codePostal,
                                  valueCommune.nomCommune,
                                );
                                getNumeroParVoie(
                                  item.referenceVoieOI
                                    ? {
                                        referenceVoieOI: item.referenceVoieOI,
                                      }
                                    : {
                                        libelleVoieOI: item.libelleVoie,
                                        communeCodeInsee: valueCommune.codeInsee,
                                      },
                                );
                              } else {
                                setValueNumero(item);
                                setNumerosList([]);
                                setDisableNumero(true);
                              }
                              setValueVoie(item);
                              setFieldValue("IMBCodeImmeuble", "");
                              setDisableSearchButton(true);
                            }}
                            renderInput={params => (
                              <TextField
                                {...params}
                                placeholder="Choisissez une voie"
                                variant="outlined"
                                fullWidth
                              />
                            )}
                          />
                          <Autocomplete
                            id="numero"
                            value={valueNumero}
                            disabled={disableNumero}
                            options={numerosList}
                            classes={{ root: "expansionPanelFormElig" }}
                            getOptionLabel={option => {
                              const { numeroVoie, complementNumeroVoie, referenceIMB } = option;
                              const complementNumero = complementNumeroVoie
                                ? ` ${option.complementNumeroVoie}`
                                : "";
                              const referenceImb = referenceIMB ? ` (${referenceIMB})` : "";

                              return numeroVoie + complementNumero + referenceImb;
                            }}
                            onChange={(e, item) => {
                              setValueNumero(item);

                              if (item != null) {
                                setFieldValue("IMBCodeImmeuble", item.referenceIMB);
                                setDisableSearchButton(false);
                              } else {
                                setFieldValue("IMBCodeImmeuble", "");
                                setDisableSearchButton(true);
                              }
                            }}
                            renderInput={params => (
                              <TextField
                                {...params}
                                placeholder="Choisissez un numero"
                                variant="outlined"
                                fullWidth
                              />
                            )}
                          />
                        </div>

                        <div className={displaySpecific ? "visible" : "hidden"}>
                          {displaySpecific && displayAdresse && (
                            <div className="divider div-transparent" />
                          )}

                          <FormikTextField
                            classes={{
                              root: "fullWidth colorTextForm fieldElig ",
                            }}
                            type="text"
                            name="IMBCodeImmeuble"
                            placeholder="Saisissez un Code Immeuble"
                            variant="outlined"
                            disabled={disableIMBField}
                            onChange={e => switchDisplayField(e.target.value, e.target.name)}
                          />
                          <FormikTextField
                            classes={{
                              root: "fullWidth colorTextForm fieldElig",
                            }}
                            type="text"
                            name="IMBHexacle"
                            placeholder="Saisissez un code Hexaclé"
                            variant="outlined"
                            disabled={disableHexacleField}
                            onChange={e => switchDisplayField(e.target.value, e.target.name)}
                          />
                          {/*
                                <div className="divider div-transparent" />
                                <div className="latLongField">
                                  <FormikTextField
                                    variant="outlined"
                                    disabled={disableLatLongField}
                                    onChange={e => {
                                      setValueLAT(e.target.value);
                                      switchDisplayField(e.target.value, e.target.name);
                                    }}
                                    type="text"
                                    name="LAT"
                                    classes={{
                                      root: "midWidth colorTextForm fieldElig",
                                    }}
                                    placeholder="Latitude"
                                  />
                                  <FormikTextField
                                    variant="outlined"
                                    disabled={disableLatLongField}
                                    onChange={e => {
                                      setValueLONG(e.target.value);
                                      switchDisplayField(e.target.value, e.target.name);
                                    }}
                                    type="text"
                                    name="LONG"
                                    classes={{
                                      root: "midWidth colorTextForm fieldElig",
                                    }}
                                    placeholder="Longitude"
                                  />
                                </div>
                                <FormikTextField
                                  variant="outlined"
                                  disabled={disableSIRETField}
                                  onChange={e => {
                                    switchDisplayField(e.target.value, e.target.name);
                                  }}
                                  type="text"
                                  name="SIRET"
                                  classes={{
                                    root: "fullWidth colorTextForm fieldElig ",
                                  }}
                                  placeholder="Saisissez un numéro de Siret"
                                />
                              */}
                        </div>
                        <div className="buttonWrapperFormElig">
                          <Typography variant="body2">
                            Votre adresse n&apos;est pas référencée ou votre immeuble est référencé
                            à la mauvaise adresse ?{" "}
                            <a href={dsp.urlChangementAdresse} target="_blank" rel="noreferrer">
                              Cliquez ici
                            </a>
                          </Typography>
                          <MuiThemeProvider theme={ButtonTheme}>
                            <span>
                              <Button
                                classes={{
                                  root: "resetButtonFormElig w-100",
                                }}
                                startIcon={<SettingsBackupRestore />}
                                onClick={handleReset}
                              >
                                Réinitialiser
                              </Button>
                            </span>
                            <span>
                              <Button
                                type="submit"
                                disabled={disableSearchButton}
                                classes={{
                                  root: "submitButtonFormElig w-100",
                                }}
                                startIcon={<Check />}
                              >
                                Rechercher
                              </Button>
                            </span>
                          </MuiThemeProvider>
                        </div>
                      </Form>
                    )}
                  />
                </div>
              </Paper>

              {prospectInitialValues && (
                <Paper elevation={3} className="paperSearch">
                  <div className="titre">
                    <span>Je souhaite être contacté</span>{" "}
                    <IconButton
                      aria-label={displayProspect ? "Fermer" : "Ouvrir"}
                      disableRipple
                      disableFocusRipple
                      className="toggleAccordionButton"
                      onClick={() => setDisplayProspect(!displayProspect)}
                    >
                      <DoubleArrow
                        classes={{
                          root: displayProspect ? "accordion" : "accordion-close",
                        }}
                      />
                    </IconButton>
                  </div>

                  <div className={displayProspect ? "visible" : "hidden"}>
                    {prospectSent && (
                      <Typography variant="body2" className="alignJustify">
                        Merci d&apos;avoir complété ce formulaire. Les opérateurs vous
                        recontacterons dès que possible. En attendant, vous pouvez voir la liste des
                        opérateurs disponibles en cliquant ici :<br />
                        <a href={dsp.urlListeOperateur} target="_blank" rel="noreferrer">
                          <Button className="markerButtonFai">Voir les opérateurs</Button>
                        </a>
                      </Typography>
                    )}
                    {!prospectSent && (
                      <Formik
                        enableReinitialize
                        initialValues={prospectInitialValues}
                        onSubmit={async (values, { resetForm }) => {
                          setIsLoading(true);
                          setIsSearching(true);

                          Prospect.createProspect({
                            civilite: values.civilite,
                            nom: values.civilite !== "Entreprise" ? values.nom : "",
                            prenom: values.civilite !== "Entreprise" ? values.prenom : "",
                            nomEntreprise:
                              values.civilite === "Entreprise" ? values.entreprise : "",
                            email: values.email,
                            telephoneFixe: values.fixe,
                            telephoneMobile: values.mobile,
                            marche: values.marche,
                            adresseCommune: `${values.codePostal} - ${values.libelleCommune}`,
                            adresseRue: values.voieAdresse,
                            adresseNum: values.numeroAdresse,
                            imb: values.imb,
                            latitude: values.latitude,
                            longitude: values.longitude,
                            resultat: values.resultat,
                            validRGPD: 1,
                          })
                            .then(() => {
                              setProspectSent(true);
                            })
                            .catch(() => {
                              enqueueSnackbar("Erreur lors de l'envoi du formulaire", {
                                variant: "error",
                                autoHideDuration: 6000,
                              });
                            })
                            .finally(() => {
                              setIsLoading(false);
                              setIsSearching(false);
                            });
                        }}
                        validationSchema={yup.object().shape(
                          {
                            civilite: yup.string().required("Renseignez la civilité"),
                            nom: yup.string().when("civilite", {
                              is: value => value !== "Entreprise",
                              then: yup.string().required("Renseignez votre nom"),
                            }),
                            prenom: yup.string().when("civilite", {
                              is: value => value !== "Entreprise",
                              then: yup.string().required("Renseignez votre prénom"),
                            }),
                            entreprise: yup.string().when("civilite", {
                              is: "Entreprise",
                              then: yup.string().required("Renseignez la raison sociale"),
                            }),
                            email: yup
                              .string()
                              .required("Renseignez votre mail")
                              .email("Veullez renseigner une adresse mail valide"),
                            rgpd: yup.boolean().required("Veuillez cocher la case"),
                            fixe: yup.string().when("mobile", {
                              is: val => !val,
                              then: yup
                                .string()
                                .required("Renseignez votre numéro de fixe")
                                .matches(
                                  /(^(0|\+33|0033)[1-9][0-9]{8}$)|(^(\+41|0041)[0-9]{9}$)|(^(\+49|0049)[0-9]{9,11}$)/,
                                  {
                                    message: "Le format est incorrect",
                                    excludeEmptyString: true,
                                  },
                                ),
                              otherwise: yup
                                .string()
                                .matches(
                                  /(^(0|\+33|0033)[1-9][0-9]{8}$)|(^(\+41|0041)[0-9]{9}$)|(^(\+49|0049)[0-9]{9,11}$)/,
                                  {
                                    message: "Le format est incorrect",
                                    excludeEmptyString: true,
                                  },
                                ),
                            }),
                            mobile: yup.string().when("fixe", {
                              is: val => !val,
                              then: yup
                                .string()
                                .required("Renseignez votre numéro de mobile")
                                .matches(
                                  /(^(0|\+33|0033)[6-7][0-9]{8}$)|(^(\+41|0041)[0-9]{9}$)|(^(\+49|0049)[0-9]{9,11}$)/,
                                  {
                                    message: "Le format est incorrect",
                                    excludeEmptyString: true,
                                  },
                                ),
                              otherwise: yup
                                .string()
                                .matches(
                                  /(^(0|\+33|0033)[1-9][0-9]{8}$)|(^(\+41|0041)[0-9]{9}$)|(^(\+49|0049)[0-9]{9,11}$)/,
                                  {
                                    message: "Le format est incorrect",
                                    excludeEmptyString: true,
                                  },
                                ),
                            }),
                          },
                          [["fixe", "mobile"]],
                        )}
                      >
                        {({ isSubmitting, values }) => (
                          <Form className="globalFormElig expansionPanelFormElig">
                            <Grid container spacing={2} justify="center">
                              <Grid item xs={12}>
                                <Typography variant="body2" className="alignJustify">
                                  Les informations recueillies à partir de ce formulaire sont{" "}
                                  nécessaires au traitement de votre demande. Elles sont{" "}
                                  enregistrées et transmises aux services de {dsp.libelle} et du
                                  Groupe Altitude Infra en charge de son traitement.
                                </Typography>
                                <br />
                                <Typography variant="body2">
                                  <span className="fontBold">Adresse testée :</span>{" "}
                                  {values.nomBatiment && <>{values.nomBatiment}, </>}
                                  {values.numeroAdresse} {values.voieAdresse}, {values.codePostal}{" "}
                                  {values.libelleCommune}
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Field
                                  component={RadioGroup}
                                  name="civilite"
                                  label=""
                                  value={values.civilite}
                                  variant="outlined"
                                  isFormik
                                  options={[
                                    { label: "M", value: "M" },
                                    { label: "Mme", value: "Mme" },
                                    { label: "Entreprise", value: "Entreprise" },
                                  ]}
                                />
                              </Grid>
                              {values.civilite !== "Entreprise" && (
                                <>
                                  <Grid item xs={12} sm={6}>
                                    <Field
                                      component={Input}
                                      type="text"
                                      name="nom"
                                      label="Nom"
                                      variant="outlined"
                                      isFormik
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <Field
                                      component={Input}
                                      type="text"
                                      name="prenom"
                                      label="Prénom"
                                      variant="outlined"
                                      isFormik
                                    />
                                  </Grid>
                                </>
                              )}
                              {values.civilite === "Entreprise" && (
                                <Grid item xs={12}>
                                  <Field
                                    component={Input}
                                    type="text"
                                    name="entreprise"
                                    label="Raison Sociale"
                                    variant="outlined"
                                    isFormik
                                  />
                                </Grid>
                              )}
                              <Grid item xs={12}>
                                <Field
                                  component={Input}
                                  type="text"
                                  name="email"
                                  label="Email"
                                  variant="outlined"
                                  isFormik
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Field
                                  component={Input}
                                  type="text"
                                  name="fixe"
                                  label="Téléphone"
                                  variant="outlined"
                                  isFormik
                                />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Field
                                  component={Input}
                                  type="text"
                                  name="mobile"
                                  label="Mobile"
                                  variant="outlined"
                                  isFormik
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <Field
                                  component={IrrisCheckBox}
                                  isFormik
                                  label={
                                    <Typography variant="body2" className="alignJustify">
                                      En cochant cette case, j&apos;accepte que mes informations
                                      soient enregistrées et utilisées, uniquement pour la finalité{" "}
                                      de ce formulaire. Pour plus d&apos;informations sur ce{" "}
                                      traitement et sur vos droits, cliquez{" "}
                                      <a
                                        href="https://rgpd.altitudeinfra.fr/"
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        ici
                                      </a>
                                      .
                                    </Typography>
                                  }
                                  name="rgpd"
                                  required
                                  variant="outlined"
                                />
                              </Grid>
                              <Grid item xs={12} sm className="alignCenter">
                                <MuiThemeProvider theme={ButtonTheme}>
                                  <a href={dsp.urlListeOperateur} target="_blank" rel="noreferrer">
                                    <Button
                                      classes={{
                                        root: "resetButtonFormElig w-100",
                                      }}
                                      onClick={() => setDisplayProspect(false)}
                                      startIcon={<RedoTwoTone />}
                                    >
                                      Passer l&apos;étape
                                    </Button>
                                  </a>
                                </MuiThemeProvider>
                              </Grid>
                              <Grid item xs={12} sm className="alignCenter">
                                <MuiThemeProvider theme={ButtonTheme}>
                                  <Button
                                    type="submit"
                                    disabled={isSubmitting}
                                    classes={{
                                      root: "submitButtonFormElig w-100",
                                    }}
                                    startIcon={<Check />}
                                  >
                                    Envoyer
                                  </Button>
                                </MuiThemeProvider>
                              </Grid>
                            </Grid>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </div>
                </Paper>
              )}

              {infoEligPro && (
                <Paper elevation={3} className="paperSearch">
                  <div className="titre">Eligibilité Fibre Premium</div>
                  <table className="listeImmeuble">
                    <tbody>
                      <tr>
                        <td
                          className={infoEligPro.resultat ? "tdEligInfoOk" : "tdEligProInfoKo"}
                          colSpan="4"
                        >
                          {infoEligPro.zone} : {infoEligPro.MessageRes}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="4" />
                      </tr>
                      {infoEligPro.pointTestLat !== "" && (
                        <tr>
                          <td colSpan="4">
                            Point testé : {infoEligPro.pointTestLat} (lat),
                            {infoEligPro.pointTestLng} (long)
                          </td>
                        </tr>
                      )}
                      {infoEligPro.siret !== "" && (
                        <>
                          <tr>
                            <td colSpan="4">Siret : {infoEligPro.siret}</td>
                          </tr>
                          {infoEligPro.siretLat !== "" && (
                            <>
                              <tr>
                                <td colSpan="4">Siret latitude : {infoEligPro.siretLat}</td>
                              </tr>
                              <tr>
                                <td colSpan="4">Siret longitude : {infoEligPro.siretLong}</td>
                              </tr>
                            </>
                          )}
                        </>
                      )}
                      {infoEligPro.resultat ? (
                        <>
                          <tr>
                            <td colSpan="4">Marché : {infoEligPro.libelleMarche}</td>
                          </tr>
                          <tr>
                            <td colSpan="4">
                              Point Fibre : {infoEligPro.pointFibreLat} (lat),{" "}
                              {infoEligPro.pointFibreLng} (long)
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="4" className="tdResultZone">
                              {infoEligPro.resultat ? (
                                <span>Eligible : ZONE </span>
                              ) : (
                                <span>Non éligible : ZONE </span>
                              )}
                              {infoEligPro.zone}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="4">
                              Distance point réseau : {parseFloat(infoEligPro.distance).toFixed(2)}{" "}
                              mètres
                            </td>
                          </tr>
                        </>
                      ) : (
                        <>
                          {infoEligPro.libelleMarche && (
                            <tr>
                              <td colSpan="4">Marché : {infoEligPro.libelleMarche}</td>
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </Paper>
              )}
              {/* FIN ELIG MUX */}

              {/* Affichage de la liste des immeubles */}
              {listeImmeublesParAdresse.length > 0 && (
                <Paper elevation={3} className="paperSearch">
                  <div className="titre">Liste des bâtiments</div>
                  <div className="tablisteSize">
                    <table className="listeImmeuble">
                      <tbody>
                        <tr>
                          <th>Code Immeuble</th>
                          <th>Adresse</th>
                          <th>Hexacle</th>
                          <th>Etat</th>
                        </tr>
                        {listeImmeublesParAdresse.length > 0 &&
                          listeImmeublesParAdresse.map((imb, index) => (
                            <tr
                              className={selectedRow === index ? imb.classColorElig : ""}
                              key={imb.referenceIMB}
                              onClick={() => {
                                setSelectedRow(index);
                                rechercheInfoIMB(imb.referenceIMB);
                              }}
                            >
                              <td>{imb.referenceIMB}</td>
                              <td>
                                {imb.numeroAdresse !== "0" && imb.numeroAdresse}{" "}
                                {imb.extensionAdresse} {imb.voieAdresse} {imb.codePostal}{" "}
                                {imb.libelleCommune}
                              </td>
                              <td>{imb.hexacle}</td>
                              <td>{imb.statutEligImmeuble}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="buttonWrapperFormElig">
                    <span>
                      <MuiThemeProvider theme={ButtonTheme}>
                        <Button
                          className="resetButtonFormElig w-100"
                          onClick={() => resultReset()}
                          startIcon={<SettingsBackupRestore />}
                        >
                          Effacer les résultats
                        </Button>
                      </MuiThemeProvider>
                    </span>
                  </div>
                </Paper>
              )}
              {displayNoResultat && (
                <Paper elevation={3} className="paperSearch">
                  <table className="listeImmeuble">
                    <tbody>
                      <tr>
                        <td colSpan="2" className="tdEligInfoKoBackground">
                          Pas d&apos;immeuble de référencé
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="buttonWrapperFormElig">
                    <span>
                      <MuiThemeProvider theme={ButtonTheme}>
                        <Button
                          className="resetButtonFormElig w-100"
                          onClick={() => resultReset()}
                          startIcon={<SettingsBackupRestore />}
                        >
                          Fermer
                        </Button>
                      </MuiThemeProvider>
                    </span>
                  </div>
                </Paper>
              )}

              {infoImmeuble && (
                <Paper elevation={3} className="paperSearch">
                  <div className="titre">Détail de l&apos;immeuble</div>
                  <table className="detailImmeuble">
                    <tbody>
                      <tr>
                        {infoImmeuble.gelCommercial && (
                          <td className={`${infoImmeuble.classColorElig} tdEligInfo`} colSpan="2">
                            {dsp.codeReseau === "AI-VENU"
                              ? "Immeuble prochainement éligible"
                              : "Immeuble momentanément suspendu"}
                          </td>
                        )}
                        {(infoImmeuble.statutEligImmeuble === "DE" ||
                          infoImmeuble.statutEligImmeuble === "RA" ||
                          infoImmeuble.statutEligImmeuble === "RD" ||
                          infoImmeuble.statutEligImmeuble === "RDEC") &&
                          !infoImmeuble.gelCommercial && (
                            <td className={`${infoImmeuble.classColorElig} tdEligInfo`} colSpan="2">
                              Immeuble éligible
                            </td>
                          )}
                        {infoImmeuble.statutEligImmeuble === "GE" && !infoImmeuble.gelCommercial && (
                          <td className={`${infoImmeuble.classColorElig} tdEligInfo`} colSpan="2">
                            Immeuble prochainement éligible
                          </td>
                        )}
                        {infoImmeuble.statutEligImmeuble !== "GE" &&
                          infoImmeuble.statutEligImmeuble !== "DE" &&
                          infoImmeuble.statutEligImmeuble !== "RA" &&
                          infoImmeuble.statutEligImmeuble !== "RD" &&
                          infoImmeuble.statutEligImmeuble !== "RDEC" &&
                          !infoImmeuble.gelCommercial && (
                            <td className={`${infoImmeuble.classColorElig} tdEligInfo`} colSpan="2">
                              Immeuble non éligible
                            </td>
                          )}
                      </tr>
                      <tr>
                        <td>
                          <b>Code Immeuble :</b> {infoImmeuble.referenceIMB}
                        </td>
                        <td>
                          <b>Hexaclé :</b> {infoImmeuble.hexacle}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2">
                          <b>Adresse :</b> {infoImmeuble.numeroAdresse}{" "}
                          {infoImmeuble.extensionAdresse} {infoImmeuble.voieAdresse},{" "}
                          {infoImmeuble.codePostal} {infoImmeuble.libelleCommune}
                        </td>
                      </tr>
                      {infoImmeuble.nomBatiment ? (
                        <tr>
                          <td colSpan="2">
                            <b>Nom bâtiment :</b> {infoImmeuble.nomBatiment}
                          </td>
                        </tr>
                      ) : null}
                      <tr>
                        <td>
                          <b>Type :</b> {infoImmeuble.typeBatiment}
                        </td>
                        <td>
                          <b>Nbre de logement :</b> {infoImmeuble.nbreLogementImmeuble}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Statut :</b> {infoImmeuble.statutEligImmeubleTxt}
                        </td>
                        <td>
                          <b>Raccordement IMB :</b> {infoImmeuble.raccoBatiment}
                        </td>
                      </tr>
                      {(!infoImmeuble.gelCommercial && infoImmeuble.dateMESCommercialeIMB) ||
                      (infoImmeuble.gelCommercial && infoImmeuble.dateFinGelCommercial) ? (
                        <tr>
                          <td colSpan="2">
                            <b>Date de commercialisation indicative :</b>{" "}
                            {!infoImmeuble.gelCommercial &&
                              infoImmeuble.dateMESCommercialeIMB &&
                              moment(infoImmeuble.dateMESCommercialeIMB).format("DD/MM/YYYY")}
                            {infoImmeuble.gelCommercial &&
                              infoImmeuble.dateFinGelCommercial &&
                              moment(infoImmeuble.dateFinGelCommercial).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      ) : null}
                      {infoImmeuble.statutEligImmeuble === "RA" ||
                      infoImmeuble.statutEligImmeuble === "DE" ||
                      infoImmeuble.statutEligImmeuble === "RD" ? (
                        <tr>
                          <td className="alignCenter" colSpan="2">
                            Contactez un fournisseur d&apos;accès partenaire de {dsp.libelle}.{" "}
                            <a href={dsp.urlListeOperateur} target="_blank" rel="noreferrer">
                              Plus d&apos;informations
                            </a>
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                  <div className="buttonWrapperFormElig">
                    <Typography variant="body2">
                      Votre adresse n&apos;est pas référencée ou votre immeuble est référencé à la
                      mauvaise adresse ?{" "}
                      <a href={dsp.urlChangementAdresse} target="_blank" rel="noreferrer">
                        Cliquez ici
                      </a>
                    </Typography>
                    <span>
                      <MuiThemeProvider theme={ButtonTheme}>
                        <Button
                          className="resetButtonFormElig w-100"
                          onClick={() => infoImmeubleReset()}
                          startIcon={<SettingsBackupRestore />}
                        >
                          Effacer les résultats
                        </Button>
                      </MuiThemeProvider>
                    </span>
                  </div>
                </Paper>
              )}
            </div>
          </Spinner>
        </Drawer>
      </MuiThemeProvider>
      {/* Affichage drawer setting */}
      <MuiThemeProvider
        theme={openSetting ? DrawerEligibiliteSearchTheme : DrawerEligibiliteSearchThemeClosed}
      >
        <Drawer variant="persistent" anchor="left" open={openSetting}>
          <Spinner isLoading={isSearching} message="" small>
            <div className="divSettingMenu">
              <Paper elevation={3} className="paperSetting">
                <div className="alignCenter drawerHeader">
                  <a href={dsp.urlSite} target="_blank" rel="noreferrer">
                    {setLogoFromDsp(dsp)}
                  </a>
                  <div className="container-close">
                    <MuiThemeProvider theme={ButtonClose}>
                      <Button
                        classes={{ root: "annulButtonFormElig" }}
                        onClick={handleDrawerLeftOpen}
                        startIcon={<Clear />}
                      />
                    </MuiThemeProvider>
                  </div>
                </div>
              </Paper>
              <Paper elevation={3} className="paperSetting">
                <div className="titre">
                  <span>Configuration de la carte</span>
                </div>
                <MuiThemeProvider theme={CheckboxTheme}>
                  <fieldset className="fieldset">
                    <legend className="legendeConfCarte">Fond de carte</legend>
                    <div className="tablisteSize">
                      <table className="listeLogement tableTwoColumns">
                        <tbody>
                          <tr>
                            <th className="alignRight" colSpan="2">
                              Afficher
                            </th>
                          </tr>
                          <tr>
                            <td>Vue Plan</td>
                            <td className="alignCenter">
                              <Checkbox
                                value="LAYER_PLAN"
                                checked={optionSelectedConfigCarte.LAYER_PLAN}
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                onChange={e => handleChangeCheckBoxConfigCarte(e)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>Vue Satellite</td>
                            <td className="alignCenter">
                              <Checkbox
                                value="LAYER_SAT"
                                checked={optionSelectedConfigCarte.LAYER_SAT}
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                onChange={e => handleChangeCheckBoxConfigCarte(e)}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </fieldset>
                  <fieldset className="fieldset">
                    <legend className="legendeConfCarte">
                      Les zones de déploiement Très Haut Débit de {dsp.libelle}
                    </legend>
                    <div className="tablisteSize">
                      <table className="listeLogement tableFourColumns">
                        <tbody>
                          <tr>
                            <th className="alignLeft" colSpan="3">
                              La fibre FttH {dsp.libelle} (grand public)
                            </th>
                            <th>
                              <Tooltip title="Tout cocher / tout décocher (sauf Très Haut Débit Radio)">
                                <Checkbox
                                  value="ALL_ZONES"
                                  checked={optionSelectedConfigCarte.ALL_ZONES}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                  onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                />
                              </Tooltip>
                            </th>
                          </tr>
                          {dsp.codeReseau === "AI-VENU" && (
                            <>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor:
                                        couleurZaDeploiement.ZASROCommercialisable20182020,
                                    }}
                                  />
                                </td>
                                <td>2018 - 2020</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlZonesDeploiement}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="SRO_DEP_201820"
                                    checked={optionSelectedConfigCarte.SRO_DEP_201820}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor:
                                        couleurZaDeploiement.ZASROCommercialisable2021,
                                    }}
                                  />
                                </td>
                                <td>2021</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlZonesDeploiement}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="SRO_DEP_2021"
                                    checked={optionSelectedConfigCarte.SRO_DEP_2021}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor:
                                        couleurZaDeploiement.ZASROCommercialisable2022,
                                    }}
                                  />
                                </td>
                                <td>2022</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlZonesDeploiement}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="SRO_DEP_2022"
                                    checked={optionSelectedConfigCarte.SRO_DEP_2022}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor:
                                        couleurZaDeploiement.ZASROCommercialisable2023,
                                    }}
                                  />
                                </td>
                                <td>2023</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlZonesDeploiement}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="SRO_DEP_2023"
                                    checked={optionSelectedConfigCarte.SRO_DEP_2023}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th className="alignLeft" colSpan="4">
                                  Couverture Très Haut Débit Radio
                                </th>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor: couleurZaDeploiement.ZONE_RADIO,
                                    }}
                                  />
                                </td>
                                <td>Zone Radio</td>
                                <td className="alignCenter">
                                  <Tooltip
                                    title={<Typography>{tooltipInfoRadio}</Typography>}
                                    placement="left"
                                    arrow
                                  >
                                    <a
                                      className="picto-info picto-info-block"
                                      href="https://www.vendeenumerique.fr/la-fibre/les-solutions-alternatives/le-tres-haut-debit-radio/"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <FontAwesomeIcon
                                        className="info-logo"
                                        icon={faInfoCircle}
                                        size="3x"
                                      />
                                    </a>
                                  </Tooltip>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="ZONE_RADIO"
                                    checked={optionSelectedConfigCarte.ZONE_RADIO}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                            </>
                          )}
                          {dsp.codeReseau !== "AI-VENU" && (
                            <>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor: couleurZaDeploiement.ZaSroOpen,
                                    }}
                                  />
                                </td>
                                <td>Ouvertes commercialement</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlZonesDeploiement}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="SRO_OPEN"
                                    checked={optionSelectedConfigCarte.SRO_OPEN}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor: couleurZaDeploiement.ZaSroSoon,
                                    }}
                                  />
                                </td>
                                <td>Ouvertes prochainement</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlZonesDeploiement}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="SRO_SOON"
                                    checked={optionSelectedConfigCarte.SRO_SOON}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                  />
                                </td>
                              </tr>
                              {/* On regroupe les zones de déploiement N0,N1,N2 en NX pour le marche AI-MNUM */}
                              {dsp.codeReseau === "AI-MNUM" ? (
                                <tr>
                                  <td className="alignCenter">
                                    <div
                                      className="legende-element-square"
                                      style={{
                                        backgroundColor: couleurZaDeploiement.ZaSroYearNX,
                                      }}
                                    />
                                  </td>
                                  <td>Travaux en cours</td>
                                  <td className="alignCenter">
                                    <a
                                      className="picto-info picto-info-block"
                                      href={dsp.urlZonesDeploiement}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <FontAwesomeIcon
                                        className="info-logo"
                                        icon={faInfoCircle}
                                        size="3x"
                                      />
                                    </a>
                                  </td>
                                  <td className="alignCenter">
                                    <Checkbox
                                      value="SRO_YEAR_NX"
                                      checked={optionSelectedConfigCarte.SRO_YEAR_NX}
                                      onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                      inputProps={{
                                        "aria-label": "primary checkbox",
                                      }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  {!(dsp.maxYear && dsp.maxYear < moment().year()) && (
                                    <tr>
                                      <td className="alignCenter">
                                        <div
                                          className="legende-element-square"
                                          style={{
                                            backgroundColor: couleurZaDeploiement.ZaSroYearN0,
                                          }}
                                        />
                                      </td>
                                      <td>{moment().year()}</td>
                                      <td className="alignCenter">
                                        <a
                                          className="picto-info picto-info-block"
                                          href={dsp.urlZonesDeploiement}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <FontAwesomeIcon
                                            className="info-logo"
                                            icon={faInfoCircle}
                                            size="3x"
                                          />
                                        </a>
                                      </td>
                                      <td className="alignCenter">
                                        <Checkbox
                                          value="SRO_YEAR_N0"
                                          checked={optionSelectedConfigCarte.SRO_YEAR_N0}
                                          onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                          inputProps={{
                                            "aria-label": "primary checkbox",
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  )}
                                  {!(dsp.maxYear && dsp.maxYear < moment().year() + 1) && (
                                    <tr>
                                      <td className="alignCenter">
                                        <div
                                          className="legende-element-square"
                                          style={{
                                            backgroundColor: couleurZaDeploiement.ZaSroYearN1,
                                          }}
                                        />
                                      </td>
                                      <td>{moment().year() + 1}</td>
                                      <td className="alignCenter">
                                        <a
                                          className="picto-info picto-info-block"
                                          href={dsp.urlZonesDeploiement}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <FontAwesomeIcon
                                            className="info-logo"
                                            icon={faInfoCircle}
                                            size="3x"
                                          />
                                        </a>
                                      </td>
                                      <td className="alignCenter">
                                        <Checkbox
                                          value="SRO_YEAR_N1"
                                          checked={optionSelectedConfigCarte.SRO_YEAR_N1}
                                          onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                          inputProps={{
                                            "aria-label": "primary checkbox",
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  )}
                                  {!(dsp.maxYear && dsp.maxYear < moment().year() + 2) && (
                                    <tr>
                                      <td className="alignCenter">
                                        <div
                                          className="legende-element-square"
                                          style={{
                                            backgroundColor: couleurZaDeploiement.ZaSroYearN2,
                                          }}
                                        />
                                      </td>
                                      <td>{moment().year() + 2}</td>
                                      <td className="alignCenter">
                                        <a
                                          className="picto-info picto-info-block"
                                          href={dsp.urlZonesDeploiement}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <FontAwesomeIcon
                                            className="info-logo"
                                            icon={faInfoCircle}
                                            size="3x"
                                          />
                                        </a>
                                      </td>
                                      <td className="alignCenter">
                                        <Checkbox
                                          value="SRO_YEAR_N2"
                                          checked={optionSelectedConfigCarte.SRO_YEAR_N2}
                                          onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                          inputProps={{
                                            "aria-label": "primary checkbox",
                                          }}
                                        />
                                      </td>
                                    </tr>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </fieldset>
                  <fieldset className="fieldset">
                    <legend className="legendeConfCarte">
                      L&apos;état d&apos;avancement de la fibre FttH (grand public)
                    </legend>
                    <div className="tablisteSize">
                      <table className="listeLogement tableFourColumns">
                        <tbody>
                          <tr>
                            <th className="alignLeft" colSpan="3">
                              Eligibilité des logements
                            </th>
                            <th>
                              <Tooltip title="Tout cocher / tout décocher">
                                <Checkbox
                                  value="ALL_STATUSES"
                                  checked={optionSelectedConfigCarte.ALL_STATUSES}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                  onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                />
                              </Tooltip>
                            </th>
                          </tr>
                          {dsp.codeReseau !== "AI-DOUB" && (
                            <tr>
                              <td className="alignCenter">
                                <div className="legende-element-image">
                                  <FontAwesomeIcon
                                    icon={faAt}
                                    style={{ color: colorIcons.raccorde }}
                                  />
                                </div>
                              </td>
                              <td>Raccordé</td>
                              <td className="alignCenter">
                                <a
                                  className="picto-info picto-info-block"
                                  href={dsp.urlFibreFtth}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <FontAwesomeIcon
                                    className="info-logo"
                                    icon={faInfoCircle}
                                    size="3x"
                                  />
                                </a>
                              </td>
                              <td className="alignCenter">
                                <Checkbox
                                  value="IMB_RAC"
                                  checked={optionSelectedConfigCarte.IMB_RAC}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                  onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                />
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td className="alignCenter">
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  style={{ color: colorIcons.deploye }}
                                />
                              </div>
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faHouseChimney}
                                  style={{ color: colorIcons.deploye }}
                                />
                              </div>
                            </td>
                            <td>Eligible</td>
                            <td className="alignCenter">
                              <a
                                className="picto-info picto-info-block"
                                href={dsp.urlFibreFtth}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <FontAwesomeIcon
                                  className="info-logo"
                                  icon={faInfoCircle}
                                  size="3x"
                                />
                              </a>
                            </td>
                            <td className="alignCenter">
                              <Checkbox
                                value="IMB_ELIG"
                                checked={optionSelectedConfigCarte.IMB_ELIG}
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                onChange={e => handleChangeCheckBoxConfigCarte(e)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="alignCenter">
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  style={{
                                    color:
                                      dsp.codeReseau === "AI-VENU"
                                        ? colorIcons.gelVendee
                                        : colorIcons.prochainementEligible,
                                  }}
                                />
                              </div>
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faHouseChimney}
                                  style={{
                                    color:
                                      dsp.codeReseau === "AI-VENU"
                                        ? colorIcons.gelVendee
                                        : colorIcons.prochainementEligible,
                                  }}
                                />
                              </div>
                            </td>
                            <td>Prochainement éligible</td>
                            <td className="alignCenter">
                              <a
                                className="picto-info picto-info-block"
                                href={dsp.urlFibreFtth}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <FontAwesomeIcon
                                  className="info-logo"
                                  icon={faInfoCircle}
                                  size="3x"
                                />
                              </a>
                            </td>
                            <td className="alignCenter">
                              <Checkbox
                                value="IMB_PROELIG"
                                checked={optionSelectedConfigCarte.IMB_PROELIG}
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                onChange={e => handleChangeCheckBoxConfigCarte(e)}
                              />
                            </td>
                          </tr>
                          {dsp.codeReseau !== "AI-VENU" && (
                            <tr>
                              <td className="alignCenter">
                                <div className="legende-element-image">
                                  <FontAwesomeIcon
                                    icon={faBuilding}
                                    style={{
                                      color: colorIcons.gelCommercial,
                                    }}
                                  />
                                </div>
                                <div className="legende-element-image">
                                  <FontAwesomeIcon
                                    icon={faHouseChimney}
                                    style={{
                                      color: colorIcons.gelCommercial,
                                    }}
                                  />
                                </div>
                              </td>
                              <td>Correction technique en cours</td>
                              <td className="alignCenter">
                                <a
                                  className="picto-info picto-info-block"
                                  href={dsp.urlFibreFtth}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <FontAwesomeIcon
                                    className="info-logo"
                                    icon={faInfoCircle}
                                    size="3x"
                                  />
                                </a>
                              </td>
                              <td className="alignCenter">
                                <Checkbox
                                  value="IMB_GELCOM"
                                  checked={optionSelectedConfigCarte.IMB_GELCOM}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                  onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                />
                              </td>
                            </tr>
                          )}
                          {dsp.codeReseau === "AI-VENU" && (
                            <>
                              <tr>
                                <td className="alignCenter">
                                  <div className="legende-element-image">
                                    <FontAwesomeIcon
                                      icon={faBuilding}
                                      style={{
                                        color: colorIcons.travauxRueVendee,
                                      }}
                                    />
                                  </div>
                                  <div className="legende-element-image">
                                    <FontAwesomeIcon
                                      icon={faHouseChimney}
                                      style={{
                                        color: colorIcons.travauxRueVendee,
                                      }}
                                    />
                                  </div>
                                </td>
                                <td>Travaux en cours dans votre rue</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlFibreFtth}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="IMB_TRAVAUX_RUE"
                                    checked={optionSelectedConfigCarte.IMB_TRAVAUX_RUE}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div className="legende-element-image">
                                    <FontAwesomeIcon
                                      icon={faBuilding}
                                      style={{
                                        color: colorIcons.travauxSecteurVendee,
                                      }}
                                    />
                                  </div>
                                  <div className="legende-element-image">
                                    <FontAwesomeIcon
                                      icon={faHouseChimney}
                                      style={{
                                        color: colorIcons.travauxSecteurVendee,
                                      }}
                                    />
                                  </div>
                                </td>
                                <td>Travaux en cours dans votre secteur</td>
                                <td className="alignCenter">
                                  <a
                                    className="picto-info picto-info-block"
                                    href={dsp.urlFibreFtth}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FontAwesomeIcon
                                      className="info-logo"
                                      icon={faInfoCircle}
                                      size="3x"
                                    />
                                  </a>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="IMB_TRAVAUX_SECTEUR"
                                    checked={optionSelectedConfigCarte.IMB_TRAVAUX_SECTEUR}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                            </>
                          )}
                          {dsp.codeReseau !== "AI-JURA" && (
                            <tr>
                              <td className="alignCenter">
                                <div className="legende-element-image">
                                  <FontAwesomeIcon
                                    icon={faBuilding}
                                    style={{
                                      color:
                                        dsp.codeReseau === "AI-VENU"
                                          ? colorIcons.demandeVendee
                                          : colorIcons.demande,
                                    }}
                                  />
                                </div>
                                <div className="legende-element-image">
                                  <FontAwesomeIcon
                                    icon={faHouseChimney}
                                    style={{
                                      color:
                                        dsp.codeReseau === "AI-VENU"
                                          ? colorIcons.demandeVendee
                                          : colorIcons.demande,
                                    }}
                                  />
                                </div>
                              </td>
                              <td>Raccordable sur demande</td>
                              <td className="alignCenter">
                                <a
                                  className="picto-info picto-info-block"
                                  href={dsp.urlFibreSurDemande}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <FontAwesomeIcon
                                    className="info-logo"
                                    icon={faInfoCircle}
                                    size="3x"
                                  />
                                </a>
                              </td>
                              <td className="alignCenter">
                                <Checkbox
                                  value="IMB_DEMANDE"
                                  checked={optionSelectedConfigCarte.IMB_DEMANDE}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                  onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                />
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td className="alignCenter">
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  style={{
                                    color:
                                      dsp.codeReseau === "AI-VENU"
                                        ? colorIcons.cibleVendee
                                        : colorIcons.cible,
                                  }}
                                />
                              </div>
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faHouseChimney}
                                  style={{
                                    color:
                                      dsp.codeReseau === "AI-VENU"
                                        ? colorIcons.cibleVendee
                                        : colorIcons.cible,
                                  }}
                                />
                              </div>
                            </td>
                            <td>En cours d&apos;étude</td>
                            <td className="alignCenter">
                              <a
                                className="picto-info picto-info-block"
                                href={dsp.urlFibreFtth}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <FontAwesomeIcon
                                  className="info-logo"
                                  icon={faInfoCircle}
                                  size="3x"
                                />
                              </a>
                            </td>
                            <td className="alignCenter">
                              <Checkbox
                                value="IMB_ETUDE"
                                checked={optionSelectedConfigCarte.IMB_ETUDE}
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                onChange={e => handleChangeCheckBoxConfigCarte(e)}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td className="alignCenter">
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faBuilding}
                                  style={{
                                    color: colorIcons.blocCollectifTiers,
                                  }}
                                />
                              </div>
                              <div className="legende-element-image">
                                <FontAwesomeIcon
                                  icon={faHouseChimney}
                                  style={{
                                    color: colorIcons.blocCollectifTiers,
                                  }}
                                />
                              </div>
                            </td>
                            <td>Blocage tiers</td>
                            <td className="alignCenter">
                              <a
                                className="picto-info picto-info-block"
                                href={dsp.urlFibreFtth}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <FontAwesomeIcon
                                  className="info-logo"
                                  icon={faInfoCircle}
                                  size="3x"
                                />
                              </a>
                            </td>
                            <td className="alignCenter">
                              <Checkbox
                                value="IMB_BLOC_COLLECTIF_TIERS"
                                checked={optionSelectedConfigCarte.IMB_BLOC_COLLECTIF_TIERS}
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                                onChange={e => handleChangeCheckBoxConfigCarte(e)}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </fieldset>
                  {dsp.codeReseau === "AI-VENU" && (
                    <>
                      <fieldset className="fieldset">
                        <legend className="legendeConfCarte">
                          La fibre professionnelle (FttE)
                        </legend>
                        <div className="tablisteSize">
                          <table className="listeLogement tableFourColumns">
                            <tbody>
                              <tr>
                                <th className="alignRight" colSpan="4">
                                  Afficher
                                </th>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div className="legende-element-image">
                                    <FontAwesomeIcon
                                      icon={faCity}
                                      style={{ color: colorIcons.deploye }}
                                    />
                                  </div>
                                </td>
                                <td>Les entreprises et bâtis publics éligibles</td>
                                <td className="alignCenter">
                                  <Tooltip
                                    title={<Typography>{tooltipInfoFTTE}</Typography>}
                                    placement="left"
                                    arrow
                                  >
                                    <a
                                      className="picto-info picto-info-block"
                                      href={dsp.urlFibreFtte}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <FontAwesomeIcon
                                        className="info-logo"
                                        icon={faInfoCircle}
                                        size="3x"
                                      />
                                    </a>
                                  </Tooltip>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="FTTE"
                                    checked={optionSelectedConfigCarte.FTTE}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </fieldset>
                      <fieldset className="fieldset">
                        <legend className="legendeConfCarte">
                          Les zones privées de déploiement de la fibre
                        </legend>
                        <div className="tablisteSize">
                          <table className="listeLogement tableFourColumns">
                            <tbody>
                              <tr>
                                <th className="alignRight" colSpan="4">
                                  Afficher
                                </th>
                              </tr>
                              <tr>
                                <td className="alignCenter">
                                  <div
                                    className="legende-element-square"
                                    style={{
                                      backgroundColor: couleurZaDeploiement.ZAAMII,
                                    }}
                                  />
                                </td>
                                <td>Déploiement de la fibre par un opérateur privé</td>
                                <td className="alignCenter">
                                  <Tooltip
                                    title={<Typography>{tooltipInfoAMII}</Typography>}
                                    placement="left"
                                    arrow
                                  >
                                    <a
                                      className="picto-info picto-info-block"
                                      href="https://www.vendeenumerique.fr/qui-sommes-nous/GIP/le-perimetre-d-intervention-de-vendee-numerique/"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <FontAwesomeIcon
                                        className="info-logo"
                                        icon={faInfoCircle}
                                        size="3x"
                                      />
                                    </a>
                                  </Tooltip>
                                </td>
                                <td className="alignCenter">
                                  <Checkbox
                                    value="ZONE_AMII"
                                    checked={optionSelectedConfigCarte.ZONE_AMII}
                                    inputProps={{
                                      "aria-label": "primary checkbox",
                                    }}
                                    onChange={e => handleChangeCheckBoxConfigCarte(e)}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </fieldset>
                    </>
                  )}
                </MuiThemeProvider>
                <div className="buttonWrapperFormElig spaceAround">
                  <MuiThemeProvider theme={ButtonTheme}>
                    <Button
                      classes={{ root: "resetButtonFormElig" }}
                      onClick={handleResetConfigMap}
                      startIcon={<SettingsBackupRestore />}
                    >
                      Réinitialiser
                    </Button>
                  </MuiThemeProvider>
                </div>
              </Paper>
            </div>
          </Spinner>
        </Drawer>
      </MuiThemeProvider>
      {/* Affichage de la légende */}
      {displayLegende && (
        <div
          className={classNames(
            "container-legende",
            (openSearch || openSetting) && "legendeWithDrawer",
            isInit && isLoading && window.innerWidth >= 992 && "legendeInitWithDrawer",
          )}
        >
          <Legende
            dsp={dsp}
            optionSelectedConfigCarte={optionSelectedConfigCarte}
            zoom={zoom}
            ZOOM_LEVEL_IMB={ZOOM_LEVEL_IMB}
            ZOOM_LEVEL_FTTE={ZOOM_LEVEL_FTTE}
            MAX_ZOOM_DISPLAY_SRO={MAX_ZOOM_DISPLAY_SRO}
            MIN_ZOOM_DISPLAY_SRO={MIN_ZOOM_DISPLAY_SRO}
            MAX_ZOOM_DISPLAY_AMII={MAX_ZOOM_DISPLAY_AMII}
            MIN_ZOOM_DISPLAY_AMII={MIN_ZOOM_DISPLAY_AMII}
          />
        </div>
      )}
      {/* Affichage carte */}
      <div
        ref={mapContainerRef}
        className={classNames(
          "map",
          (openSearch || openSetting) && "mapWithDrawer",
          isInit && isLoading && window.innerWidth < 992 && "mapInit",
          isInit &&
            isLoading &&
            (openSearch || openSetting) &&
            window.innerWidth >= 992 &&
            "mapInitWithDrawer",
        )}
      >
        <Spinner isLoading={isLoading} message="">
          <Map
            ref={mapRef}
            center={POSITION_CENTER}
            zoom={zoom}
            minZoom={MIN_ZOOM_MAP}
            maxZoom={MAX_ZOOM_MAP}
            maxBounds={MAX_BOUNDS}
            boundsOptions={{ paddingBottomRight: [800, 0] }}
            attributionControl={false}
            keyboard={false}
            tap={false}
            zoomControl={false}
            dragging
            doubleClickZoom
            scrollWheelZoom
            touchZoom
            onMoveEnd={e => onZoomOrDrag(e)}
            onZoomEnd={e => setZoom(e.target.getZoom())}
            onPopupClose={() => setIsAutoPanning(false)}
            onPopupOpen={e => {
              setIsAutoPanning(true);

              const px = mapRef.current.leafletElement.project(e.target._popup._latlng);

              px.y -= e.target._popup._container.clientHeight / 2;
              mapRef.current.leafletElement.panTo(mapRef.current.leafletElement.unproject(px));
            }}
          >
            <ScaleControl position="bottomleft" imperial={false} />
            <AttributionControl position="bottomright" prefix={false} />
            <div className="wrapperAffichageDistanceEtChargementIMB">
              {chargementIMBWtk && (
                <div className="affichageChargementIMBWtk pulse">
                  Chargement des immeubles de la zone en cours...
                </div>
              )}
            </div>

            {/* tuiles */}
            <TileLayer
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
              url={urlLayer}
              attribution={`<div><a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | © Contributeurs de OpenStreetMap</div>
                      <div>© Altitude Infrastructure |${" "}
                      ${dateVersion && `maj le ${dateVersion}`}</div>`}
              maxZoom={24}
            />
            {/* Contours Marche */}
            {marcheList.length > 0 && (
              <ZaMarche
                dsp={dsp}
                marcheList={marcheList}
                zoom={zoom}
                MAX_ZOOM_DISPLAY_MARCHE={MAX_ZOOM_DISPLAY_MARCHE}
                resetCoordonnees={resetCoordonnees}
                setIsLoading={setIsLoadingZaMarche}
                transmissionCoordonnees={target => resetMapView(target)}
              />
            )}
            {/* Contours Commune */}
            {codeInsee && (
              <ZaCommune
                codeInsee={codeInsee}
                transmissionCoordonnees={target => resetMapView(target)}
              />
            )}
            {/* ZA Radio */}
            {dsp.codeReseau === "AI-VENU" && (
              <ZaRadioVN
                codeReseau={dsp.codeReseau}
                optionSelectedConfigCarte={optionSelectedConfigCarte}
                setIsLoading={setIsLoadingZaRadioVN}
              />
            )}
            {/* ZA AMII VN */}
            {dsp.codeReseau === "AI-VENU" && (
              <ZaAmiiVN
                optionSelectedConfigCarte={optionSelectedConfigCarte}
                zoom={zoom}
                MIN_ZOOM_DISPLAY_AMII={MIN_ZOOM_DISPLAY_AMII}
                MAX_ZOOM_DISPLAY_AMII={MAX_ZOOM_DISPLAY_AMII}
                setIsLoading={setIsLoadingZaAmiiVN}
              />
            )}
            {/* ZA SRO */}
            {dsp && (
              <ZaSro
                dsp={dsp}
                marcheList={marcheList}
                optionSelectedConfigCarte={optionSelectedConfigCarte}
                zoom={zoom}
                MIN_ZOOM_DISPLAY_SRO={MIN_ZOOM_DISPLAY_SRO}
                MAX_ZOOM_DISPLAY_SRO={MAX_ZOOM_DISPLAY_SRO}
                setIsLoading={setIsLoadingZaSro}
              />
            )}
            {/* Marker d'immeuble */}
            {dsp && (
              <MarkersImb
                dsp={dsp}
                imbWkt={imbWkt}
                marcheList={marcheList}
                positionMarkerTarget={positionMarkerTarget}
                optionSelectedConfigCarte={optionSelectedConfigCarte}
                zoom={zoom}
                isMobileLandscape={isMobileLandscape}
                displayMarkerImb={displayMarkerImb}
                ZOOM_LEVEL_IMB={ZOOM_LEVEL_IMB}
                ZOOM_LEVEL_FTTE={ZOOM_LEVEL_FTTE}
                setChargementIMBWtk={setChargementIMBWtk}
                onMarkerImbClick={onMarkerImbClick}
                onOperatorPopupClick={onOperatorPopupClick}
                rechercheParSiret={rechercheParSiret}
              />
            )}
          </Map>
        </Spinner>
      </div>
    </>
  );
};

Eligibilite.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
    maxYear: propTypes.number,
    secondaryMarches: propTypes.array,
  }).isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(Eligibilite);
